"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedMerchantDocumentTypes = exports.supportedThirdPartyLeadDocumentTypeToPathMap = exports.supportedThirdPartyLeadDocumentPathToTypeMap = exports.UserDocumentUploadErrors = exports.supportedMortgageDocuments = exports.supportedManualReviewProperty = exports.supportedNonOwnerOccupiedCurrentRent = exports.supportedManualReviewIncomes = exports.documentPathForType = exports.documentTypeForPath = exports.documentUploadTypeRequiresUpload = exports.NON_UPLOAD_DOCUMENT_UPLOAD_TYPES = exports.HUMAN_READABLE_NAME_FOR_DOCUMENT_UPLOAD_TYPE = exports.USER_UPLOADED_INCOME_VERIFICATION_DOCUMENT_TYPE_PATHS = exports.MANUAL_INCOME_VERIFICATION_DOCUMENT_UPLOAD_TYPES = exports.DocumentTypePath = exports.DocumentUploadType = exports.DocumentUploadAttribution = exports.UploadSource = void 0;
exports.isMerchantDocumentType = isMerchantDocumentType;
const lodash_1 = __importDefault(require("lodash"));
/**
 * Declared origin of an upload; other IDs on the document may describe its subject.
 * @TranslateToPython
 */
var UploadSource;
(function (UploadSource) {
    UploadSource["applicant"] = "applicant";
    UploadSource["autoApplicant"] = "autoApplicant";
    UploadSource["thirdPartyLead"] = "thirdPartyLead";
    UploadSource["mlo"] = "mlo";
    UploadSource["partnerUser"] = "partnerUser";
    UploadSource["ops"] = "ops";
})(UploadSource || (exports.UploadSource = UploadSource = {}));
/** Dashboard attribution of an upload, relative to the authenticated partner viewer. */
var DocumentUploadAttribution;
(function (DocumentUploadAttribution) {
    DocumentUploadAttribution["currentPartnerUser"] = "currentPartnerUser";
    DocumentUploadAttribution["applicant"] = "applicant";
})(DocumentUploadAttribution || (exports.DocumentUploadAttribution = DocumentUploadAttribution = {}));
/** @TranslateToPython */
var DocumentUploadType;
(function (DocumentUploadType) {
    DocumentUploadType["PAY_STUB"] = "PAY_STUB";
    DocumentUploadType["W2"] = "W2";
    DocumentUploadType["TAX_RETURN"] = "TAX_RETURN";
    DocumentUploadType["STATE_TAX_RETURN"] = "STATE_TAX_RETURN";
    DocumentUploadType["IRS_RECORD_OF_ACCOUNT"] = "IRS_RECORD_OF_ACCOUNT";
    DocumentUploadType["IRS_WAGE_AND_INCOME_TRANSCRIPT"] = "IRS_WAGE_AND_INCOME_TRANSCRIPT";
    DocumentUploadType["IRS_REJECTION_NOTICE"] = "IRS_REJECTION_NOTICE";
    DocumentUploadType["IRS_TAX_RETURN_TRANSCRIPT"] = "IRS_TAX_RETURN_TRANSCRIPT";
    DocumentUploadType["BANK_STATEMENT"] = "BANK_STATEMENT";
    DocumentUploadType["FORM_1099"] = "FORM_1099";
    DocumentUploadType["FORM_1099_R"] = "FORM_1099_R";
    DocumentUploadType["FORM_1099_SSA"] = "FORM_1099_SSA";
    DocumentUploadType["FORM_1099_MISC"] = "FORM_1099_MISC";
    DocumentUploadType["FORM_1099_NEC"] = "FORM_1099_NEC";
    DocumentUploadType["PROFIT_AND_LOSS"] = "PROFIT_AND_LOSS";
    DocumentUploadType["SCHEDULE_C"] = "SCHEDULE_C";
    DocumentUploadType["BENEFIT_LETTER"] = "BENEFIT_LETTER";
    DocumentUploadType["OTHER_INCOME_LETTER"] = "OTHER_INCOME_LETTER";
    DocumentUploadType["BANK_STATEMENT_FOR_CASH_OUT"] = "BANK_STATEMENT_FOR_CASH_OUT";
    DocumentUploadType["UTILITY_BILL"] = "UTILITY_BILL";
    DocumentUploadType["QUIT_CLAIM"] = "QUIT_CLAIM";
    DocumentUploadType["LAST_TRANSFER_DOCUMENT"] = "LAST_TRANSFER_DOCUMENT";
    DocumentUploadType["GRANT_DEED"] = "GRANT_DEED";
    DocumentUploadType["INTERSPOUSAL_TRANSFER"] = "INTERSPOUSAL_TRANSFER";
    DocumentUploadType["DEATH_CERTIFICATE"] = "DEATH_CERTIFICATE";
    DocumentUploadType["IDENTITY_DOCUMENT"] = "IDENTITY_DOCUMENT";
    DocumentUploadType["CARDHOLDER_AGREEMENT"] = "CARDHOLDER_AGREEMENT";
    DocumentUploadType["OFFER_CONTINGENCY_STATUS_DOCUMENT"] = "OFFER_CONTINGENCY_STATUS_DOCUMENT";
    DocumentUploadType["RECORDED_DEED_OF_TRUST"] = "RECORDED_DEED_OF_TRUST";
    DocumentUploadType["RECORDED_TX_AFFIDAVIT"] = "RECORDED_TX_AFFIDAVIT";
    DocumentUploadType["STATES_TITLE_PACKAGE"] = "STATES_TITLE_PACKAGE";
    DocumentUploadType["ACCOUNT_CLOSING_DOCUMENT"] = "ACCOUNT_CLOSING_DOCUMENT";
    DocumentUploadType["INSURANCE_DOCUMENT"] = "INSURANCE_DOCUMENT";
    DocumentUploadType["SUBORDINATION_DOCUMENT"] = "SUBORDINATION_DOCUMENT";
    DocumentUploadType["DEED_OF_TRUST_AMENDMENT"] = "DEED_OF_TRUST_AMENDMENT";
    DocumentUploadType["MORTGAGE_DOCUMENT"] = "MORTGAGE_DOCUMENT";
    DocumentUploadType["VOIDED_CHECK"] = "VOIDED_CHECK";
    DocumentUploadType["OFAC"] = "OFAC";
    DocumentUploadType["SUPPORTING_DOCUMENT"] = "SUPPORTING_DOCUMENT";
    DocumentUploadType["PHONE_BILL"] = "PHONE_BILL";
    DocumentUploadType["FLOOD_INSURANCE_DOCUMENT"] = "FLOOD_INSURANCE_DOCUMENT";
    DocumentUploadType["AUTO_INSURANCE_DOCUMENT"] = "AUTO_INSURANCE_DOCUMENT";
    DocumentUploadType["TITLE_INSURANCE_DOCUMENT"] = "TITLE_INSURANCE_DOCUMENT";
    DocumentUploadType["HOMEOWNERS_INSURANCE_DOCUMENT"] = "HOMEOWNERS_INSURANCE_DOCUMENT";
    DocumentUploadType["CONDO_HOA_DOCUMENT"] = "CONDO_HOA_DOCUMENT";
    DocumentUploadType["DISPUTE_PROVIDER_DATA_DOCUMENT"] = "DISPUTE_PROVIDER_DATA_DOCUMENT";
    DocumentUploadType["SCANNED_RIN_DOCUMENT"] = "SCANNED_RIN_DOCUMENT";
    DocumentUploadType["TRANSACTION_DISPUTE_SUPPORTING_DOCUMENT"] = "TRANSACTION_DISPUTE_SUPPORTING_DOCUMENT";
    DocumentUploadType["FAST_FUNDING_VIDEO"] = "FAST_FUNDING_VIDEO";
    DocumentUploadType["FINAL_TITLE_INSURANCE_POLICY"] = "DOMAFinalTitlePolicy";
    DocumentUploadType["TITLE_INSURANCE_PRELIMINARY_REPORT"] = "TITLE_INSURANCE_PRELIMINARY_REPORT";
    DocumentUploadType["LEGAL_DESCRIPTION"] = "LegalDescription";
    DocumentUploadType["DISPUTE_CO_OWNER_DOCUMENT"] = "DISPUTE_CO_OWNER_DOCUMENT";
    DocumentUploadType["SOCIAL_SECURITY_CARD_TAX_TRANSCRIPT_1040_RETURN_RECEIPT"] = "SOCIAL_SECURITY_CARD_TAX_TRANSCRIPT_1040_RETURN_RECEIPT";
    DocumentUploadType["SOCIAL_SECURITY_CARD"] = "SOCIAL_SECURITY_CARD";
    DocumentUploadType["SECOND_FORM_OF_GOVERNMENT_ISSUED_ID"] = "SECOND_FORM_OF_GOVERNMENT_ISSUED_ID";
    DocumentUploadType["DIVORCE_DECREE"] = "DIVORCE_DECREE";
    DocumentUploadType["WARRANTY_DEED"] = "WARRANTY_DEED";
    DocumentUploadType["VOICE_VERIFICATION"] = "VOICE_VERIFICATION";
    DocumentUploadType["RECORDED_RECONVEYANCE"] = "RECORDED_RECONVEYANCE";
    DocumentUploadType["COMPETITOR_AGREEMENT"] = "COMPETITOR_AGREEMENT";
    DocumentUploadType["COMPETITOR_AGREEMENT_V2"] = "COMPETITOR_AGREEMENT_V2";
    DocumentUploadType["MORTGAGE_STATEMENT"] = "MORTGAGE_STATEMENT";
    DocumentUploadType["AVEN_SIGNING_DOCUMENT"] = "AVEN_SIGNING_DOCUMENT";
    DocumentUploadType["AVEN_SIGNED_DOCUMENT"] = "AVEN_SIGNED_DOCUMENT";
    DocumentUploadType["CREATOR_CHALLENGE_VIDEO"] = "CREATOR_CHALLENGE_VIDEO";
    DocumentUploadType["SOCIAL_SECURITY"] = "SOCIAL_SECURITY";
    DocumentUploadType["PENSION"] = "PENSION";
    DocumentUploadType["RETIREMENT"] = "RETIREMENT";
    DocumentUploadType["PRIOR_HELOC_STATEMENT"] = "PRIOR_HELOC_STATEMENT";
    DocumentUploadType["FIRST_LIEN_MORTGAGE_STATEMENT"] = "FIRST_LIEN_MORTGAGE_STATEMENT";
    DocumentUploadType["MULTI_LIEN_REFI_MORTGAGE_STATEMENT"] = "MULTI_LIEN_REFI_MORTGAGE_STATEMENT";
    /** @deprecated NOO_V2 was removed 2025-12-26 */
    DocumentUploadType["VERIFY_CURRENT_RENT_BANK_STATEMENT"] = "VERIFY_CURRENT_RENT_BANK_STATEMENT";
    /** @deprecated NOO_V2 was removed 2025-12-26 */
    DocumentUploadType["VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT"] = "VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT";
    DocumentUploadType["FIRST_LIEN_DOC"] = "FIRST_LIEN_DOC";
    DocumentUploadType["ALL_LIEN_DOC"] = "ALL_LIEN_DOC";
    DocumentUploadType["HELOC_REFI_PAYOFF_QUOTE"] = "HELOC_REFI_PAYOFF_QUOTE";
    DocumentUploadType["BANK_STATEMENT_ASSET_VERIFICATION"] = "BANK_STATEMENT_ASSET_VERIFICATION";
    DocumentUploadType["AVEN_ACCOUNT_TERMINATION_LETTER"] = "AVEN_ACCOUNT_TERMINATION_LETTER";
    DocumentUploadType["BANKRUPTCY_DOCUMENT"] = "BANKRUPTCY_DOCUMENT";
    DocumentUploadType["FORECLOSURE_SOT"] = "FORECLOSURE_SOT";
    DocumentUploadType["FORECLOSURE_NOD"] = "FORECLOSURE_NOD";
    DocumentUploadType["FORECLOSURE_OTHER"] = "FORECLOSURE_OTHER";
    DocumentUploadType["FORECLOSURE_TSG"] = "FORECLOSURE_TSG";
    DocumentUploadType["MANUAL_PAYOFF_QUOTE"] = "MANUAL_PAYOFF_QUOTE";
    DocumentUploadType["QUALIFIED_WRITTEN_REQUEST"] = "QUALIFIED_WRITTEN_REQUEST";
    DocumentUploadType["DEBT_VALIDATION_LETTER_RESPONSE"] = "DEBT_VALIDATION_LETTER_RESPONSE";
    DocumentUploadType["STATEMENT_RESERVES_VERIFICATION"] = "STATEMENT_RESERVES_VERIFICATION";
    DocumentUploadType["BROKERAGE_STATEMENT_ASSET_VERIFICATION"] = "BROKERAGE_STATEMENT_ASSET_VERIFICATION";
    DocumentUploadType["HELOC_REFI_LENDER_CONFIRMATION_OF_FUNDS_RECEIVED"] = "HELOC_REFI_LENDER_CONFIRMATION_OF_FUNDS_RECEIVED";
    DocumentUploadType["HELOC_REFI_PAID_IN_FULL_LETTER"] = "HELOC_REFI_PAID_IN_FULL_LETTER";
    DocumentUploadType["HELOC_REFI_SATISFACTION_OF_MORTGAGE"] = "HELOC_REFI_SATISFACTION_OF_MORTGAGE";
    DocumentUploadType["HELOC_REFI_RECORDED_RECONVEYANCE"] = "HELOC_REFI_RECORDED_RECONVEYANCE";
    DocumentUploadType["HELOC_REFI_SIGNED_BORROWER_AUTH"] = "HELOC_REFI_SIGNED_BORROWER_AUTH";
    DocumentUploadType["TITLE_INSURANCE_CLOSING_PACKAGE"] = "TITLE_INSURANCE_CLOSING_PACKAGE";
    DocumentUploadType["CLOSING_PACKAGE_ATTORNEY_APPROVAL"] = "CLOSING_PACKAGE_ATTORNEY_APPROVAL";
    DocumentUploadType["MORTGAGE_LAW_RETURN_DOCUMENT"] = "MORTGAGE_LAW_RETURN_DOCUMENT";
    DocumentUploadType["TITLE_INSURANCE_VESTING_DEED"] = "TITLE_INSURANCE_VESTING_DEED";
    DocumentUploadType["TITLE_INSURANCE_TAX_CERTIFICATE"] = "TITLE_INSURANCE_TAX_CERTIFICATE";
    DocumentUploadType["STATEMENT_OF_INFORMATION"] = "STATEMENT_OF_INFORMATION";
    DocumentUploadType["THIRD_PARTY_LEAD_TRANSFER_DEED"] = "THIRD_PARTY_LEAD_TRANSFER_DEED";
    DocumentUploadType["THIRD_PARTY_LEAD_IDENTITY_DOCUMENT"] = "THIRD_PARTY_LEAD_IDENTITY_DOCUMENT";
    DocumentUploadType["STATE_CLOSING_DOCUMENT"] = "STATE_CLOSING_DOCUMENT";
    DocumentUploadType["APPRAISAL_REPORT"] = "APPRAISAL_REPORT";
    DocumentUploadType["BALANCE_TRANSFER_SAVINGS_GUARANTEE_APR_VERIFICATION"] = "BALANCE_TRANSFER_SAVINGS_GUARANTEE_APR_VERIFICATION";
    DocumentUploadType["ARB_OPT_OUT"] = "ARB_OPT_OUT";
    DocumentUploadType["CIP_EVIDENCE"] = "CIP_EVIDENCE";
    DocumentUploadType["IDOLOGY_REPORT"] = "IDOLOGY_REPORT";
    DocumentUploadType["MERCHANT_CONTRACT"] = "MERCHANT_CONTRACT";
    DocumentUploadType["MERCHANT_WORK_ORDER"] = "MERCHANT_WORK_ORDER";
    DocumentUploadType["MERCHANT_ADDENDUM"] = "MERCHANT_ADDENDUM";
    DocumentUploadType["MERCHANT_COMPLETION_CERTIFICATE"] = "MERCHANT_COMPLETION_CERTIFICATE";
    DocumentUploadType["MERCHANT_JOB_PHOTO"] = "MERCHANT_JOB_PHOTO";
    DocumentUploadType["MERCHANT_OTHER"] = "MERCHANT_OTHER";
    DocumentUploadType["BUSINESS_ARTICLES_OF_ORGANIZATION"] = "BUSINESS_ARTICLES_OF_ORGANIZATION";
    DocumentUploadType["BUSINESS_CERTIFICATE_OF_GOOD_STANDING"] = "BUSINESS_CERTIFICATE_OF_GOOD_STANDING";
    DocumentUploadType["BUSINESS_OWNERSHIP_CERTIFICATION_OR_OPERATING_AGREEMENT"] = "BUSINESS_OWNERSHIP_CERTIFICATION_OR_OPERATING_AGREEMENT";
    DocumentUploadType["BUSINESS_OWNERSHIP_TAX_RETURN"] = "BUSINESS_OWNERSHIP_TAX_RETURN";
    DocumentUploadType["BUSINESS_OWNERSHIP_INCOME_DOC"] = "BUSINESS_OWNERSHIP_INCOME_DOC";
    // Asset-verification fund-source proof documents. The applicant classifies each flagged transaction's fund
    // source and uploads the specific proof, which is persisted at this leaf granularity (see
    // ASSET_FUNDING_SOURCE_DOCUMENT_TYPES). Generic bank/pay/tax leaves reuse the existing members above.
    DocumentUploadType["DEPOSIT_RECEIPT"] = "DEPOSIT_RECEIPT";
    DocumentUploadType["WIRE_CONFIRMATION"] = "WIRE_CONFIRMATION";
    DocumentUploadType["GIFT_LETTER"] = "GIFT_LETTER";
    DocumentUploadType["BILL_OF_SALE"] = "BILL_OF_SALE";
    DocumentUploadType["SETTLEMENT_STATEMENT"] = "SETTLEMENT_STATEMENT";
    DocumentUploadType["ESCROW_STATEMENT"] = "ESCROW_STATEMENT";
    DocumentUploadType["BROKERAGE_STATEMENT"] = "BROKERAGE_STATEMENT";
    DocumentUploadType["RETIREMENT_ACCOUNT_STATEMENT"] = "RETIREMENT_ACCOUNT_STATEMENT";
    DocumentUploadType["INSURANCE_CLAIM_DOCUMENTATION"] = "INSURANCE_CLAIM_DOCUMENTATION";
    DocumentUploadType["COURT_SETTLEMENT_DOCUMENTS"] = "COURT_SETTLEMENT_DOCUMENTS";
    DocumentUploadType["TRUST_OR_ESTATE_DOCUMENTS"] = "TRUST_OR_ESTATE_DOCUMENTS";
    DocumentUploadType["CERTIFICATE_OF_TRUST"] = "CERTIFICATE_OF_TRUST";
    DocumentUploadType["LOAN_AGREEMENT_OR_PROMISSORY_NOTE"] = "LOAN_AGREEMENT_OR_PROMISSORY_NOTE";
    DocumentUploadType["INHERITANCE_DOCUMENTATION"] = "INHERITANCE_DOCUMENTATION";
    DocumentUploadType["INVOICE_AND_PROOF_OF_PAYMENT"] = "INVOICE_AND_PROOF_OF_PAYMENT";
    DocumentUploadType["BUSINESS_FINANCIAL_STATEMENTS"] = "BUSINESS_FINANCIAL_STATEMENTS";
    // Asset-verification funding-source leaves. Each is a granular funding source an applicant can classify a
    // flagged transaction as (see ASSET_VERIFICATION_FUNDING_SOURCE_TO_DOCUMENT_TYPES). PENSION is reused from above.
    // Employment & Income
    DocumentUploadType["PAYROLL_DIRECT_DEPOSIT"] = "PAYROLL_DIRECT_DEPOSIT";
    DocumentUploadType["BONUS"] = "BONUS";
    DocumentUploadType["COMMISSION"] = "COMMISSION";
    DocumentUploadType["OVERTIME_PAY"] = "OVERTIME_PAY";
    DocumentUploadType["TIPS"] = "TIPS";
    DocumentUploadType["SEVERANCE_PAY"] = "SEVERANCE_PAY";
    DocumentUploadType["PTO_PAY_OUT"] = "PTO_PAY_OUT";
    DocumentUploadType["EXPENSE_REIMBURSEMENT"] = "EXPENSE_REIMBURSEMENT";
    DocumentUploadType["INDEPENDENT_CONTRACTOR_INCOME"] = "INDEPENDENT_CONTRACTOR_INCOME";
    DocumentUploadType["SELF_EMPLOYMENT_BUSINESS_INCOME"] = "SELF_EMPLOYMENT_BUSINESS_INCOME";
    // Retirement & Government Benefits
    DocumentUploadType["SOCIAL_SECURITY_RETIREMENT"] = "SOCIAL_SECURITY_RETIREMENT";
    DocumentUploadType["SOCIAL_SECURITY_DISABILITY"] = "SOCIAL_SECURITY_DISABILITY";
    DocumentUploadType["SUPPLEMENTAL_SECURITY_INCOME"] = "SUPPLEMENTAL_SECURITY_INCOME";
    DocumentUploadType["ANNUITY_PAYMENTS"] = "ANNUITY_PAYMENTS";
    DocumentUploadType["VETERANS_BENEFITS"] = "VETERANS_BENEFITS";
    DocumentUploadType["RAILROAD_RETIREMENT"] = "RAILROAD_RETIREMENT";
    DocumentUploadType["STATE_RETIREMENT_BENEFITS"] = "STATE_RETIREMENT_BENEFITS";
    DocumentUploadType["MILITARY_RETIREMENT"] = "MILITARY_RETIREMENT";
    // Transfers
    DocumentUploadType["TRANSFER_FROM_PERSONAL_ACCOUNT"] = "TRANSFER_FROM_PERSONAL_ACCOUNT";
    DocumentUploadType["TRANSFER_FROM_JOINT_ACCOUNT"] = "TRANSFER_FROM_JOINT_ACCOUNT";
    DocumentUploadType["BROKERAGE_ACCOUNT_TRANSFER"] = "BROKERAGE_ACCOUNT_TRANSFER";
    DocumentUploadType["SAVINGS_ACCOUNT_TRANSFER"] = "SAVINGS_ACCOUNT_TRANSFER";
    DocumentUploadType["CREDIT_UNION_TRANSFER"] = "CREDIT_UNION_TRANSFER";
    DocumentUploadType["MONEY_MARKET_TRANSFER"] = "MONEY_MARKET_TRANSFER";
    DocumentUploadType["TRUST_ACCOUNT_TRANSFER"] = "TRUST_ACCOUNT_TRANSFER";
    DocumentUploadType["CD_MATURITY_PROCEEDS"] = "CD_MATURITY_PROCEEDS";
    DocumentUploadType["INTERNATIONAL_WIRE_TRANSFER"] = "INTERNATIONAL_WIRE_TRANSFER";
    DocumentUploadType["INTERNAL_BANK_TRANSFER"] = "INTERNAL_BANK_TRANSFER";
    // Sale of Assets
    DocumentUploadType["SALE_OF_HOME"] = "SALE_OF_HOME";
    DocumentUploadType["SALE_OF_LAND"] = "SALE_OF_LAND";
    DocumentUploadType["SALE_OF_VEHICLE"] = "SALE_OF_VEHICLE";
    DocumentUploadType["SALE_OF_BOAT"] = "SALE_OF_BOAT";
    DocumentUploadType["SALE_OF_RV"] = "SALE_OF_RV";
    DocumentUploadType["SALE_OF_MOTORCYCLE"] = "SALE_OF_MOTORCYCLE";
    DocumentUploadType["SALE_OF_BUSINESS"] = "SALE_OF_BUSINESS";
    DocumentUploadType["SALE_OF_STOCKS"] = "SALE_OF_STOCKS";
    DocumentUploadType["SALE_OF_BONDS"] = "SALE_OF_BONDS";
    DocumentUploadType["SALE_OF_MUTUAL_FUNDS"] = "SALE_OF_MUTUAL_FUNDS";
    DocumentUploadType["SALE_OF_CRYPTOCURRENCY"] = "SALE_OF_CRYPTOCURRENCY";
    DocumentUploadType["SALE_OF_COLLECTIBLES"] = "SALE_OF_COLLECTIBLES";
    DocumentUploadType["ESTATE_SALE_PROCEEDS"] = "ESTATE_SALE_PROCEEDS";
    // Investments
    DocumentUploadType["STOCK_DIVIDENDS"] = "STOCK_DIVIDENDS";
    DocumentUploadType["BOND_INTEREST"] = "BOND_INTEREST";
    DocumentUploadType["MUTUAL_FUND_DISTRIBUTION"] = "MUTUAL_FUND_DISTRIBUTION";
    DocumentUploadType["CAPITAL_GAINS_DISTRIBUTION"] = "CAPITAL_GAINS_DISTRIBUTION";
    DocumentUploadType["INVESTMENT_ACCOUNT_WITHDRAWAL"] = "INVESTMENT_ACCOUNT_WITHDRAWAL";
    DocumentUploadType["RETIREMENT_ACCOUNT_DISTRIBUTION"] = "RETIREMENT_ACCOUNT_DISTRIBUTION";
    DocumentUploadType["REQUIRED_MINIMUM_DISTRIBUTION"] = "REQUIRED_MINIMUM_DISTRIBUTION";
    // Insurance
    DocumentUploadType["LIFE_INSURANCE_PAYOUT"] = "LIFE_INSURANCE_PAYOUT";
    DocumentUploadType["HEALTH_INSURANCE_REIMBURSEMENT"] = "HEALTH_INSURANCE_REIMBURSEMENT";
    DocumentUploadType["AUTO_INSURANCE_CLAIM"] = "AUTO_INSURANCE_CLAIM";
    DocumentUploadType["HOMEOWNERS_INSURANCE_CLAIM"] = "HOMEOWNERS_INSURANCE_CLAIM";
    DocumentUploadType["DISABILITY_INSURANCE_BENEFITS"] = "DISABILITY_INSURANCE_BENEFITS";
    DocumentUploadType["LONG_TERM_CARE_INSURANCE_PAYOUT"] = "LONG_TERM_CARE_INSURANCE_PAYOUT";
    // Real Estate
    DocumentUploadType["RENTAL_INCOME"] = "RENTAL_INCOME";
    DocumentUploadType["SECURITY_DEPOSIT_REFUND"] = "SECURITY_DEPOSIT_REFUND";
    DocumentUploadType["ESCROW_REFUND"] = "ESCROW_REFUND";
    DocumentUploadType["PROPERTY_TAX_REFUND"] = "PROPERTY_TAX_REFUND";
    DocumentUploadType["MORTGAGE_ESCROW_SURPLUS"] = "MORTGAGE_ESCROW_SURPLUS";
    DocumentUploadType["HOME_EQUITY_LOAN_PROCEEDS"] = "HOME_EQUITY_LOAN_PROCEEDS";
    DocumentUploadType["HELOC_ADVANCE"] = "HELOC_ADVANCE";
    DocumentUploadType["CASH_OUT_REFINANCE_PROCEEDS"] = "CASH_OUT_REFINANCE_PROCEEDS";
    DocumentUploadType["HOME_SALE_PROCEEDS"] = "HOME_SALE_PROCEEDS";
    // Loans
    DocumentUploadType["PERSONAL_LOAN_PROCEEDS"] = "PERSONAL_LOAN_PROCEEDS";
    DocumentUploadType["AUTO_LOAN_PROCEEDS"] = "AUTO_LOAN_PROCEEDS";
    DocumentUploadType["STUDENT_LOAN_DISBURSEMENT"] = "STUDENT_LOAN_DISBURSEMENT";
    DocumentUploadType["BUSINESS_LOAN_PROCEEDS"] = "BUSINESS_LOAN_PROCEEDS";
    DocumentUploadType["SBA_LOAN_PROCEEDS"] = "SBA_LOAN_PROCEEDS";
    DocumentUploadType["CONSTRUCTION_LOAN_DRAW"] = "CONSTRUCTION_LOAN_DRAW";
    DocumentUploadType["PRIVATE_LOAN_FROM_FAMILY_FRIEND"] = "PRIVATE_LOAN_FROM_FAMILY_FRIEND";
    DocumentUploadType["MARGIN_LOAN"] = "MARGIN_LOAN";
    DocumentUploadType["LINE_OF_CREDIT_ADVANCE"] = "LINE_OF_CREDIT_ADVANCE";
    // Gifts & Family
    DocumentUploadType["GIFT_FROM_FAMILY_MEMBER"] = "GIFT_FROM_FAMILY_MEMBER";
    DocumentUploadType["GIFT_FROM_FRIEND"] = "GIFT_FROM_FRIEND";
    DocumentUploadType["WEDDING_GIFT"] = "WEDDING_GIFT";
    DocumentUploadType["GRADUATION_GIFT"] = "GRADUATION_GIFT";
    DocumentUploadType["BIRTHDAY_GIFT"] = "BIRTHDAY_GIFT";
    DocumentUploadType["INHERITANCE"] = "INHERITANCE";
    DocumentUploadType["TRUST_DISTRIBUTION"] = "TRUST_DISTRIBUTION";
    // Legal & Settlement
    DocumentUploadType["LAWSUIT_SETTLEMENT"] = "LAWSUIT_SETTLEMENT";
    DocumentUploadType["CLASS_ACTION_SETTLEMENT"] = "CLASS_ACTION_SETTLEMENT";
    DocumentUploadType["WORKERS_COMPENSATION_SETTLEMENT"] = "WORKERS_COMPENSATION_SETTLEMENT";
    DocumentUploadType["PERSONAL_INJURY_SETTLEMENT"] = "PERSONAL_INJURY_SETTLEMENT";
    DocumentUploadType["DIVORCE_SETTLEMENT"] = "DIVORCE_SETTLEMENT";
    DocumentUploadType["CHILD_SUPPORT_PAYMENT"] = "CHILD_SUPPORT_PAYMENT";
    DocumentUploadType["ALIMONY"] = "ALIMONY";
    DocumentUploadType["ESTATE_DISTRIBUTION"] = "ESTATE_DISTRIBUTION";
    // Business
    DocumentUploadType["CUSTOMER_PAYMENTS"] = "CUSTOMER_PAYMENTS";
    DocumentUploadType["MERCHANT_SERVICES_DEPOSITS"] = "MERCHANT_SERVICES_DEPOSITS";
    DocumentUploadType["ACCOUNTS_RECEIVABLE_COLLECTIONS"] = "ACCOUNTS_RECEIVABLE_COLLECTIONS";
    DocumentUploadType["VENDOR_REFUND"] = "VENDOR_REFUND";
    DocumentUploadType["TAX_REFUND_TO_BUSINESS"] = "TAX_REFUND_TO_BUSINESS";
    DocumentUploadType["OWNER_CONTRIBUTION"] = "OWNER_CONTRIBUTION";
    DocumentUploadType["PARTNER_CAPITAL_CONTRIBUTION"] = "PARTNER_CAPITAL_CONTRIBUTION";
    DocumentUploadType["BUSINESS_INSURANCE_CLAIM"] = "BUSINESS_INSURANCE_CLAIM";
    // Tax-Related
    DocumentUploadType["FEDERAL_INCOME_TAX_REFUND"] = "FEDERAL_INCOME_TAX_REFUND";
    DocumentUploadType["STATE_INCOME_TAX_REFUND"] = "STATE_INCOME_TAX_REFUND";
    DocumentUploadType["SALES_TAX_REFUND"] = "SALES_TAX_REFUND";
    DocumentUploadType["IRS_CREDIT_OR_REBATE"] = "IRS_CREDIT_OR_REBATE";
    // Education
    DocumentUploadType["STUDENT_FINANCIAL_AID_REFUND"] = "STUDENT_FINANCIAL_AID_REFUND";
    DocumentUploadType["SCHOLARSHIP_REFUND"] = "SCHOLARSHIP_REFUND";
    DocumentUploadType["GRANT_PROCEEDS"] = "GRANT_PROCEEDS";
    DocumentUploadType["TUITION_REIMBURSEMENT"] = "TUITION_REIMBURSEMENT";
    // Gambling & Gaming
    DocumentUploadType["CASINO_WINNINGS"] = "CASINO_WINNINGS";
    DocumentUploadType["LOTTERY_WINNINGS"] = "LOTTERY_WINNINGS";
    DocumentUploadType["SPORTS_BETTING_WINNINGS"] = "SPORTS_BETTING_WINNINGS";
    DocumentUploadType["POKER_TOURNAMENT_WINNINGS"] = "POKER_TOURNAMENT_WINNINGS";
    DocumentUploadType["SWEEPSTAKES_PRIZE"] = "SWEEPSTAKES_PRIZE";
    // Online Platforms
    DocumentUploadType["PAYPAL_TRANSFER"] = "PAYPAL_TRANSFER";
    DocumentUploadType["VENMO_TRANSFER"] = "VENMO_TRANSFER";
    DocumentUploadType["CASH_APP_TRANSFER"] = "CASH_APP_TRANSFER";
    DocumentUploadType["ZELLE_PAYMENT"] = "ZELLE_PAYMENT";
    DocumentUploadType["STRIPE_PAYOUT"] = "STRIPE_PAYOUT";
    DocumentUploadType["SQUARE_PAYOUT"] = "SQUARE_PAYOUT";
    DocumentUploadType["ETSY_PAYOUT"] = "ETSY_PAYOUT";
    DocumentUploadType["EBAY_PAYOUT"] = "EBAY_PAYOUT";
    DocumentUploadType["AMAZON_SELLER_PAYOUT"] = "AMAZON_SELLER_PAYOUT";
    DocumentUploadType["AIRBNB_PAYOUT"] = "AIRBNB_PAYOUT";
    DocumentUploadType["VRBO_PAYOUT"] = "VRBO_PAYOUT";
    DocumentUploadType["UBER_LYFT_EARNINGS"] = "UBER_LYFT_EARNINGS";
    DocumentUploadType["DOOR_DASH_INSTACART_EARNINGS"] = "DOOR_DASH_INSTACART_EARNINGS";
    // Cash Deposits
    DocumentUploadType["PERSONAL_CASH_SAVINGS"] = "PERSONAL_CASH_SAVINGS";
    DocumentUploadType["CASH_FROM_BUSINESS_RECEIPTS"] = "CASH_FROM_BUSINESS_RECEIPTS";
    DocumentUploadType["CASH_GIFT"] = "CASH_GIFT";
    DocumentUploadType["CASH_FROM_SALE_OF_PERSONAL_PROPERTY"] = "CASH_FROM_SALE_OF_PERSONAL_PROPERTY";
    // Refunds & Credits
    DocumentUploadType["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    DocumentUploadType["CREDIT_CARD_REFUND"] = "CREDIT_CARD_REFUND";
    DocumentUploadType["UTILITY_DEPOSIT_REFUND"] = "UTILITY_DEPOSIT_REFUND";
    DocumentUploadType["WARRANTY_REIMBURSEMENT"] = "WARRANTY_REIMBURSEMENT";
    DocumentUploadType["MANUFACTURER_REBATE"] = "MANUFACTURER_REBATE";
    // Miscellaneous
    DocumentUploadType["PRIZE_OR_AWARD"] = "PRIZE_OR_AWARD";
    DocumentUploadType["ROYALTIES"] = "ROYALTIES";
    DocumentUploadType["LICENSING_INCOME"] = "LICENSING_INCOME";
    DocumentUploadType["PATENT_INCOME"] = "PATENT_INCOME";
    DocumentUploadType["COPYRIGHT_INCOME"] = "COPYRIGHT_INCOME";
    DocumentUploadType["MINERAL_OR_OIL_RIGHTS_ROYALTIES"] = "MINERAL_OR_OIL_RIGHTS_ROYALTIES";
    DocumentUploadType["CROWDFUNDING_PROCEEDS"] = "CROWDFUNDING_PROCEEDS";
    DocumentUploadType["CHARITABLE_GRANT"] = "CHARITABLE_GRANT";
    DocumentUploadType["CHURCH_ASSISTANCE"] = "CHURCH_ASSISTANCE";
    DocumentUploadType["DISASTER_RELIEF_FUNDS"] = "DISASTER_RELIEF_FUNDS";
    DocumentUploadType["FOREIGN_CURRENCY_EXCHANGE_PROCEEDS"] = "FOREIGN_CURRENCY_EXCHANGE_PROCEEDS";
    // Post-notarization review requestable documents (fraud / OFAC / CIP). Identity & occupancy documents,
    // name-change records, and verification actions ops can request the borrower provide. Some of these are
    // "actions" rather than uploads (PERSONA_SESSION, IDOLOGY_KBA, and the existing VOICE_VERIFICATION) —
    // see NON_UPLOAD_DOCUMENT_UPLOAD_TYPES for that distinction (derived from the type, not stored per-request).
    DocumentUploadType["US_DRIVERS_LICENSE"] = "US_DRIVERS_LICENSE";
    DocumentUploadType["US_STATE_ID_CARD"] = "US_STATE_ID_CARD";
    DocumentUploadType["US_PASSPORT"] = "US_PASSPORT";
    DocumentUploadType["US_PASSPORT_CARD"] = "US_PASSPORT_CARD";
    DocumentUploadType["US_PERMANENT_RESIDENT_CARD"] = "US_PERMANENT_RESIDENT_CARD";
    DocumentUploadType["TRIBAL_ID_CARD"] = "TRIBAL_ID_CARD";
    DocumentUploadType["US_DEPT_OF_STATE_DRIVERS_LICENSE"] = "US_DEPT_OF_STATE_DRIVERS_LICENSE";
    DocumentUploadType["US_EMPLOYMENT_AUTHORIZATION_CARD"] = "US_EMPLOYMENT_AUTHORIZATION_CARD";
    DocumentUploadType["US_BIRTH_CERTIFICATE"] = "US_BIRTH_CERTIFICATE";
    DocumentUploadType["US_MILITARY_ID"] = "US_MILITARY_ID";
    DocumentUploadType["GLOBAL_ENTRY_CARD"] = "GLOBAL_ENTRY_CARD";
    DocumentUploadType["US_CERTIFICATE_OF_NATURALIZATION"] = "US_CERTIFICATE_OF_NATURALIZATION";
    DocumentUploadType["FOREIGN_PASSPORT"] = "FOREIGN_PASSPORT";
    DocumentUploadType["STATE_DIGITAL_ID"] = "STATE_DIGITAL_ID";
    DocumentUploadType["ITIN_ASSIGNMENT_LETTER_CP565"] = "ITIN_ASSIGNMENT_LETTER_CP565";
    DocumentUploadType["PROPERTY_TAX_STATEMENT"] = "PROPERTY_TAX_STATEMENT";
    DocumentUploadType["LANDLORD_INSURANCE_POLICY"] = "LANDLORD_INSURANCE_POLICY";
    DocumentUploadType["LEASE_AGREEMENT"] = "LEASE_AGREEMENT";
    DocumentUploadType["MARRIAGE_CERTIFICATE"] = "MARRIAGE_CERTIFICATE";
    DocumentUploadType["COURT_ORDER_NAME_CHANGE"] = "COURT_ORDER_NAME_CHANGE";
    DocumentUploadType["FORM_1099_B"] = "FORM_1099_B";
    DocumentUploadType["POWER_OF_ATTORNEY"] = "POWER_OF_ATTORNEY";
    DocumentUploadType["IDENTITY_THEFT_WRITTEN_STATEMENT"] = "IDENTITY_THEFT_WRITTEN_STATEMENT";
    DocumentUploadType["PERSONA_SESSION"] = "PERSONA_SESSION";
    DocumentUploadType["IDOLOGY_KBA"] = "IDOLOGY_KBA";
})(DocumentUploadType || (exports.DocumentUploadType = DocumentUploadType = {}));
var DocumentTypePath;
(function (DocumentTypePath) {
    DocumentTypePath["BANK_STATEMENT"] = "bankStatement";
    DocumentTypePath["FORM_1099"] = "form1099";
    DocumentTypePath["FORM_1099_R"] = "form1099R";
    DocumentTypePath["FORM_1099_SSA"] = "form1099SSA";
    DocumentTypePath["FORM_1099_MISC"] = "form1099MISC";
    DocumentTypePath["FORM_1099_NEC"] = "form1099NEC";
    DocumentTypePath["SCHEDULE_C"] = "scheduleC";
    DocumentTypePath["PAY_STUB"] = "payStub";
    DocumentTypePath["TAX_RETURN"] = "taxReturn";
    DocumentTypePath["STATE_TAX_RETURN"] = "stateTaxReturn";
    DocumentTypePath["IRS_RECORD_OF_ACCOUNT"] = "irsRecordOfAccount";
    DocumentTypePath["IRS_WAGE_AND_INCOME_TRANSCRIPT"] = "irsWageAndIncomeTranscript";
    DocumentTypePath["IRS_REJECTION_NOTICE"] = "irsRejectionNotice";
    DocumentTypePath["IRS_TAX_RETURN_TRANSCRIPT"] = "irsTaxReturnTranscript";
    DocumentTypePath["W2"] = "w2";
    DocumentTypePath["BENEFIT_LETTER"] = "benefitLetter";
    DocumentTypePath["OTHER_INCOME_LETTER"] = "otherIncomeLetter";
    DocumentTypePath["BANK_STATEMENT_FOR_CASH_OUT"] = "bankStatementForCashOut";
    DocumentTypePath["UTILITY_BILL"] = "utilityBill";
    DocumentTypePath["QUIT_CLAIM"] = "quitClaim";
    DocumentTypePath["LAST_TRANSFER_DOCUMENT"] = "lastTransferDocument";
    DocumentTypePath["GRANT_DEED"] = "grantDeed";
    DocumentTypePath["INTERSPOUSAL_TRANSFER"] = "interspousalTransfer";
    DocumentTypePath["DEATH_CERTIFICATE"] = "deathCertificate";
    DocumentTypePath["IDENTITY_DOCUMENT"] = "identityDocument";
    DocumentTypePath["CARDHOLDER_AGREEMENT"] = "cardholderAgreement";
    DocumentTypePath["OFFER_CONTINGENCY_STATUS_DOCUMENT"] = "offerContingencyStatusDocument";
    DocumentTypePath["RECORDED_DEED_OF_TRUST"] = "recordedDeedOfTrust";
    DocumentTypePath["RECORDED_TX_AFFIDAVIT"] = "recordedTxAffidavit";
    DocumentTypePath["STATES_TITLE_PACKAGE"] = "statesTitlePackage";
    DocumentTypePath["ACCOUNT_CLOSING_DOCUMENT"] = "accountClosingDocument";
    DocumentTypePath["INSURANCE_DOCUMENT"] = "insuranceDocument";
    DocumentTypePath["SUBORDINATION_DOCUMENT"] = "subordinationDocument";
    DocumentTypePath["DEED_OF_TRUST_AMENDMENT"] = "deedOfTrustAmendment";
    DocumentTypePath["MORTGAGE_DOCUMENT"] = "mortgageDocument";
    DocumentTypePath["VOIDED_CHECK"] = "voidedCheck";
    DocumentTypePath["OFAC"] = "OFAC";
    DocumentTypePath["SUPPORTING_DOCUMENT"] = "supportingDocument";
    DocumentTypePath["PHONE_BILL"] = "phoneBill";
    DocumentTypePath["FLOOD_INSURANCE_DOCUMENT"] = "floodInsuranceDocument";
    DocumentTypePath["AUTO_INSURANCE_DOCUMENT"] = "autoInsuranceDocument";
    DocumentTypePath["TITLE_INSURANCE_DOCUMENT"] = "titleInsuranceDocument";
    DocumentTypePath["HOMEOWNERS_INSURANCE_DOCUMENT"] = "homeownersInsuranceDocument";
    DocumentTypePath["CONDO_HOA_DOCUMENT"] = "condoHoaDocument";
    DocumentTypePath["DISPUTE_PROVIDER_DATA_DOCUMENT"] = "disputeProviderDataDocument";
    DocumentTypePath["SCANNED_RIN_DOCUMENT"] = "scannedRinDocument";
    DocumentTypePath["TRANSACTION_DISPUTE_SUPPORTING_DOCUMENT"] = "transactionDisputeSupportingDocument";
    DocumentTypePath["FAST_FUNDING_VIDEO"] = "fastFundingVideo";
    DocumentTypePath["FINAL_TITLE_INSURANCE_POLICY"] = "DOMAFinalTitlePolicy";
    DocumentTypePath["TITLE_INSURANCE_PRELIMINARY_REPORT"] = "TitleInsurancePreliminaryReport";
    DocumentTypePath["LEGAL_DESCRIPTION"] = "LegalDescription";
    DocumentTypePath["DISPUTE_CO_OWNER_DOCUMENT"] = "disputeCoOwnerDocument";
    DocumentTypePath["SOCIAL_SECURITY_CARD_TAX_TRANSCRIPT_1040_RETURN_RECEIPT"] = "socialSecurityCardTaxTranscript1040WithReturnReceipt";
    DocumentTypePath["SOCIAL_SECURITY_CARD"] = "SOCIAL_SECURITY_CARD";
    DocumentTypePath["SECOND_FORM_OF_GOVERNMENT_ISSUED_ID"] = "secondFormOfGovernmentIssuedId";
    DocumentTypePath["DIVORCE_DECREE"] = "divorceDecree";
    DocumentTypePath["WARRANTY_DEED"] = "warrantyDeed";
    DocumentTypePath["VOICE_VERIFICATION"] = "voiceVerification";
    DocumentTypePath["RECORDED_RECONVEYANCE"] = "recordedReconveyance";
    DocumentTypePath["COMPETITOR_AGREEMENT"] = "competitorAgreement";
    DocumentTypePath["COMPETITOR_AGREEMENT_V2"] = "competitorAgreementV2";
    DocumentTypePath["MORTGAGE_STATEMENT"] = "mortgageStatement";
    DocumentTypePath["AVEN_SIGNING_DOCUMENT"] = "avenSigningDocument";
    DocumentTypePath["AVEN_SIGNED_DOCUMENT"] = "avenSignedDocument";
    DocumentTypePath["CREATOR_CHALLENGE_VIDEO"] = "creatorChallengeVideo";
    DocumentTypePath["PROFIT_AND_LOSS"] = "profitAndLoss";
    DocumentTypePath["SOCIAL_SECURITY"] = "socialSecurity";
    DocumentTypePath["PENSION"] = "pension";
    DocumentTypePath["RETIREMENT"] = "retirement";
    DocumentTypePath["PRIOR_HELOC_STATEMENT"] = "priorHelocStatement";
    DocumentTypePath["FIRST_LIEN_MORTGAGE_STATEMENT"] = "firstLienMortgageStatement";
    DocumentTypePath["MULTI_LIEN_REFI_MORTGAGE_STATEMENT"] = "multiLienRefiMortgageStatement";
    DocumentTypePath["VERIFY_CURRENT_RENT_BANK_STATEMENT"] = "verifyCurrentRentBankStatement";
    DocumentTypePath["VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT"] = "verifyCurrentRentPropertyMgmtStatement";
    DocumentTypePath["FIRST_LIEN_DOC"] = "firstLienDoc";
    DocumentTypePath["ALL_LIEN_DOC"] = "allLienDoc";
    DocumentTypePath["HELOC_REFI_PAYOFF_QUOTE"] = "helocRefiPayoffQuote";
    DocumentTypePath["BANK_STATEMENT_ASSET_VERIFICATION"] = "bankStatementAssetVerification";
    DocumentTypePath["AVEN_ACCOUNT_TERMINATION_LETTER"] = "avenAccountTerminationLetter";
    DocumentTypePath["BANKRUPTCY_DOCUMENT"] = "bankruptcyDocument";
    DocumentTypePath["FORECLOSURE_SOT"] = "foreclosureSOT";
    DocumentTypePath["FORECLOSURE_NOD"] = "foreclosureNOD";
    DocumentTypePath["FORECLOSURE_OTHER"] = "foreclosureOther";
    DocumentTypePath["FORECLOSURE_TSG"] = "foreclosureTSG";
    DocumentTypePath["MANUAL_PAYOFF_QUOTE"] = "manualPayoffQuote";
    DocumentTypePath["QUALIFIED_WRITTEN_REQUEST"] = "qualifiedWrittenRequest";
    DocumentTypePath["DEBT_VALIDATION_LETTER_RESPONSE"] = "debtValidationLetterResponse";
    DocumentTypePath["STATEMENT_RESERVES_VERIFICATION"] = "statementReservesVerification";
    DocumentTypePath["BROKERAGE_STATEMENT_ASSET_VERIFICATION"] = "brokerageStatementAssetVerification";
    DocumentTypePath["HELOC_REFI_LENDER_CONFIRMATION_OF_FUNDS_RECEIVED"] = "helocRefiLenderConfirmationOfFundsReceived";
    DocumentTypePath["HELOC_REFI_PAID_IN_FULL_LETTER"] = "helocRefiPaidInFullLetter";
    DocumentTypePath["HELOC_REFI_SATISFACTION_OF_MORTGAGE"] = "helocRefiSatisfactionOfMortgage";
    DocumentTypePath["HELOC_REFI_RECORDED_RECONVEYANCE"] = "helocRefiRecordedReconveyance";
    DocumentTypePath["HELOC_REFI_SIGNED_BORROWER_AUTH"] = "helocRefiSignedBorrowerAuth";
    DocumentTypePath["TITLE_INSURANCE_CLOSING_PACKAGE"] = "titleInsuranceClosingPackage";
    DocumentTypePath["CLOSING_PACKAGE_ATTORNEY_APPROVAL"] = "closingPackageAttorneyApproval";
    DocumentTypePath["MORTGAGE_LAW_RETURN_DOCUMENT"] = "mortgageLawReturnDocument";
    DocumentTypePath["TITLE_INSURANCE_VESTING_DEED"] = "titleInsuranceVestingDeed";
    DocumentTypePath["TITLE_INSURANCE_TAX_CERTIFICATE"] = "titleInsuranceTaxCertificate";
    DocumentTypePath["STATEMENT_OF_INFORMATION"] = "statementOfInformation";
    DocumentTypePath["THIRD_PARTY_LEAD_TRANSFER_DEED"] = "thirdPartyLeadTransferDeed";
    DocumentTypePath["THIRD_PARTY_LEAD_IDENTITY_DOCUMENT"] = "thirdPartyLeadIdentityDocument";
    DocumentTypePath["STATE_CLOSING_DOCUMENT"] = "stateClosingDocument";
    DocumentTypePath["APPRAISAL_REPORT"] = "appraisalReport";
    DocumentTypePath["BALANCE_TRANSFER_SAVINGS_GUARANTEE_APR_VERIFICATION"] = "balanceTransferSavingsGuaranteeAprVerification";
    DocumentTypePath["ARB_OPT_OUT"] = "arbOptOut";
    DocumentTypePath["CIP_EVIDENCE"] = "cipEvidence";
    DocumentTypePath["IDOLOGY_REPORT"] = "idologyReport";
    DocumentTypePath["MERCHANT_CONTRACT"] = "merchantContract";
    DocumentTypePath["MERCHANT_WORK_ORDER"] = "merchantWorkOrder";
    DocumentTypePath["MERCHANT_ADDENDUM"] = "merchantAddendum";
    DocumentTypePath["MERCHANT_COMPLETION_CERTIFICATE"] = "merchantCompletionCertificate";
    DocumentTypePath["MERCHANT_JOB_PHOTO"] = "merchantJobPhoto";
    DocumentTypePath["MERCHANT_OTHER"] = "merchantOther";
    DocumentTypePath["BUSINESS_ARTICLES_OF_ORGANIZATION"] = "businessArticlesOfOrganization";
    DocumentTypePath["BUSINESS_CERTIFICATE_OF_GOOD_STANDING"] = "businessCertificateOfGoodStanding";
    DocumentTypePath["BUSINESS_OWNERSHIP_CERTIFICATION_OR_OPERATING_AGREEMENT"] = "businessOwnershipCertificationOrOperatingAgreement";
    DocumentTypePath["BUSINESS_OWNERSHIP_TAX_RETURN"] = "businessOwnershipTaxReturn";
    DocumentTypePath["BUSINESS_OWNERSHIP_INCOME_DOC"] = "businessOwnershipIncomeDoc";
    // Asset-verification fund-source proof documents (see matching DocumentUploadType members).
    DocumentTypePath["DEPOSIT_RECEIPT"] = "depositReceipt";
    DocumentTypePath["WIRE_CONFIRMATION"] = "wireConfirmation";
    DocumentTypePath["GIFT_LETTER"] = "giftLetter";
    DocumentTypePath["BILL_OF_SALE"] = "billOfSale";
    DocumentTypePath["SETTLEMENT_STATEMENT"] = "settlementStatement";
    DocumentTypePath["ESCROW_STATEMENT"] = "escrowStatement";
    DocumentTypePath["BROKERAGE_STATEMENT"] = "brokerageStatement";
    DocumentTypePath["RETIREMENT_ACCOUNT_STATEMENT"] = "retirementAccountStatement";
    DocumentTypePath["INSURANCE_CLAIM_DOCUMENTATION"] = "insuranceClaimDocumentation";
    DocumentTypePath["COURT_SETTLEMENT_DOCUMENTS"] = "courtSettlementDocuments";
    DocumentTypePath["TRUST_OR_ESTATE_DOCUMENTS"] = "trustOrEstateDocuments";
    DocumentTypePath["CERTIFICATE_OF_TRUST"] = "certificateOfTrust";
    DocumentTypePath["LOAN_AGREEMENT_OR_PROMISSORY_NOTE"] = "loanAgreementOrPromissoryNote";
    DocumentTypePath["INHERITANCE_DOCUMENTATION"] = "inheritanceDocumentation";
    DocumentTypePath["INVOICE_AND_PROOF_OF_PAYMENT"] = "invoiceAndProofOfPayment";
    DocumentTypePath["BUSINESS_FINANCIAL_STATEMENTS"] = "businessFinancialStatements";
    // Asset-verification funding-source leaves (see matching DocumentUploadType members).
    // Employment & Income
    DocumentTypePath["PAYROLL_DIRECT_DEPOSIT"] = "payrollDirectDeposit";
    DocumentTypePath["BONUS"] = "bonus";
    DocumentTypePath["COMMISSION"] = "commission";
    DocumentTypePath["OVERTIME_PAY"] = "overtimePay";
    DocumentTypePath["TIPS"] = "tips";
    DocumentTypePath["SEVERANCE_PAY"] = "severancePay";
    DocumentTypePath["PTO_PAY_OUT"] = "ptoPayOut";
    DocumentTypePath["EXPENSE_REIMBURSEMENT"] = "expenseReimbursement";
    DocumentTypePath["INDEPENDENT_CONTRACTOR_INCOME"] = "independentContractorIncome";
    DocumentTypePath["SELF_EMPLOYMENT_BUSINESS_INCOME"] = "selfEmploymentBusinessIncome";
    // Retirement & Government Benefits
    DocumentTypePath["SOCIAL_SECURITY_RETIREMENT"] = "socialSecurityRetirement";
    DocumentTypePath["SOCIAL_SECURITY_DISABILITY"] = "socialSecurityDisability";
    DocumentTypePath["SUPPLEMENTAL_SECURITY_INCOME"] = "supplementalSecurityIncome";
    DocumentTypePath["ANNUITY_PAYMENTS"] = "annuityPayments";
    DocumentTypePath["VETERANS_BENEFITS"] = "veteransBenefits";
    DocumentTypePath["RAILROAD_RETIREMENT"] = "railroadRetirement";
    DocumentTypePath["STATE_RETIREMENT_BENEFITS"] = "stateRetirementBenefits";
    DocumentTypePath["MILITARY_RETIREMENT"] = "militaryRetirement";
    // Transfers
    DocumentTypePath["TRANSFER_FROM_PERSONAL_ACCOUNT"] = "transferFromPersonalAccount";
    DocumentTypePath["TRANSFER_FROM_JOINT_ACCOUNT"] = "transferFromJointAccount";
    DocumentTypePath["BROKERAGE_ACCOUNT_TRANSFER"] = "brokerageAccountTransfer";
    DocumentTypePath["SAVINGS_ACCOUNT_TRANSFER"] = "savingsAccountTransfer";
    DocumentTypePath["CREDIT_UNION_TRANSFER"] = "creditUnionTransfer";
    DocumentTypePath["MONEY_MARKET_TRANSFER"] = "moneyMarketTransfer";
    DocumentTypePath["TRUST_ACCOUNT_TRANSFER"] = "trustAccountTransfer";
    DocumentTypePath["CD_MATURITY_PROCEEDS"] = "cdMaturityProceeds";
    DocumentTypePath["INTERNATIONAL_WIRE_TRANSFER"] = "internationalWireTransfer";
    DocumentTypePath["INTERNAL_BANK_TRANSFER"] = "internalBankTransfer";
    // Sale of Assets
    DocumentTypePath["SALE_OF_HOME"] = "saleOfHome";
    DocumentTypePath["SALE_OF_LAND"] = "saleOfLand";
    DocumentTypePath["SALE_OF_VEHICLE"] = "saleOfVehicle";
    DocumentTypePath["SALE_OF_BOAT"] = "saleOfBoat";
    DocumentTypePath["SALE_OF_RV"] = "saleOfRv";
    DocumentTypePath["SALE_OF_MOTORCYCLE"] = "saleOfMotorcycle";
    DocumentTypePath["SALE_OF_BUSINESS"] = "saleOfBusiness";
    DocumentTypePath["SALE_OF_STOCKS"] = "saleOfStocks";
    DocumentTypePath["SALE_OF_BONDS"] = "saleOfBonds";
    DocumentTypePath["SALE_OF_MUTUAL_FUNDS"] = "saleOfMutualFunds";
    DocumentTypePath["SALE_OF_CRYPTOCURRENCY"] = "saleOfCryptocurrency";
    DocumentTypePath["SALE_OF_COLLECTIBLES"] = "saleOfCollectibles";
    DocumentTypePath["ESTATE_SALE_PROCEEDS"] = "estateSaleProceeds";
    // Investments
    DocumentTypePath["STOCK_DIVIDENDS"] = "stockDividends";
    DocumentTypePath["BOND_INTEREST"] = "bondInterest";
    DocumentTypePath["MUTUAL_FUND_DISTRIBUTION"] = "mutualFundDistribution";
    DocumentTypePath["CAPITAL_GAINS_DISTRIBUTION"] = "capitalGainsDistribution";
    DocumentTypePath["INVESTMENT_ACCOUNT_WITHDRAWAL"] = "investmentAccountWithdrawal";
    DocumentTypePath["RETIREMENT_ACCOUNT_DISTRIBUTION"] = "retirementAccountDistribution";
    DocumentTypePath["REQUIRED_MINIMUM_DISTRIBUTION"] = "requiredMinimumDistribution";
    // Insurance
    DocumentTypePath["LIFE_INSURANCE_PAYOUT"] = "lifeInsurancePayout";
    DocumentTypePath["HEALTH_INSURANCE_REIMBURSEMENT"] = "healthInsuranceReimbursement";
    DocumentTypePath["AUTO_INSURANCE_CLAIM"] = "autoInsuranceClaim";
    DocumentTypePath["HOMEOWNERS_INSURANCE_CLAIM"] = "homeownersInsuranceClaim";
    DocumentTypePath["DISABILITY_INSURANCE_BENEFITS"] = "disabilityInsuranceBenefits";
    DocumentTypePath["LONG_TERM_CARE_INSURANCE_PAYOUT"] = "longTermCareInsurancePayout";
    // Real Estate
    DocumentTypePath["RENTAL_INCOME"] = "rentalIncome";
    DocumentTypePath["SECURITY_DEPOSIT_REFUND"] = "securityDepositRefund";
    DocumentTypePath["ESCROW_REFUND"] = "escrowRefund";
    DocumentTypePath["PROPERTY_TAX_REFUND"] = "propertyTaxRefund";
    DocumentTypePath["MORTGAGE_ESCROW_SURPLUS"] = "mortgageEscrowSurplus";
    DocumentTypePath["HOME_EQUITY_LOAN_PROCEEDS"] = "homeEquityLoanProceeds";
    DocumentTypePath["HELOC_ADVANCE"] = "helocAdvance";
    DocumentTypePath["CASH_OUT_REFINANCE_PROCEEDS"] = "cashOutRefinanceProceeds";
    DocumentTypePath["HOME_SALE_PROCEEDS"] = "homeSaleProceeds";
    // Loans
    DocumentTypePath["PERSONAL_LOAN_PROCEEDS"] = "personalLoanProceeds";
    DocumentTypePath["AUTO_LOAN_PROCEEDS"] = "autoLoanProceeds";
    DocumentTypePath["STUDENT_LOAN_DISBURSEMENT"] = "studentLoanDisbursement";
    DocumentTypePath["BUSINESS_LOAN_PROCEEDS"] = "businessLoanProceeds";
    DocumentTypePath["SBA_LOAN_PROCEEDS"] = "sbaLoanProceeds";
    DocumentTypePath["CONSTRUCTION_LOAN_DRAW"] = "constructionLoanDraw";
    DocumentTypePath["PRIVATE_LOAN_FROM_FAMILY_FRIEND"] = "privateLoanFromFamilyFriend";
    DocumentTypePath["MARGIN_LOAN"] = "marginLoan";
    DocumentTypePath["LINE_OF_CREDIT_ADVANCE"] = "lineOfCreditAdvance";
    // Gifts & Family
    DocumentTypePath["GIFT_FROM_FAMILY_MEMBER"] = "giftFromFamilyMember";
    DocumentTypePath["GIFT_FROM_FRIEND"] = "giftFromFriend";
    DocumentTypePath["WEDDING_GIFT"] = "weddingGift";
    DocumentTypePath["GRADUATION_GIFT"] = "graduationGift";
    DocumentTypePath["BIRTHDAY_GIFT"] = "birthdayGift";
    DocumentTypePath["INHERITANCE"] = "inheritance";
    DocumentTypePath["TRUST_DISTRIBUTION"] = "trustDistribution";
    // Legal & Settlement
    DocumentTypePath["LAWSUIT_SETTLEMENT"] = "lawsuitSettlement";
    DocumentTypePath["CLASS_ACTION_SETTLEMENT"] = "classActionSettlement";
    DocumentTypePath["WORKERS_COMPENSATION_SETTLEMENT"] = "workersCompensationSettlement";
    DocumentTypePath["PERSONAL_INJURY_SETTLEMENT"] = "personalInjurySettlement";
    DocumentTypePath["DIVORCE_SETTLEMENT"] = "divorceSettlement";
    DocumentTypePath["CHILD_SUPPORT_PAYMENT"] = "childSupportPayment";
    DocumentTypePath["ALIMONY"] = "alimony";
    DocumentTypePath["ESTATE_DISTRIBUTION"] = "estateDistribution";
    // Business
    DocumentTypePath["CUSTOMER_PAYMENTS"] = "customerPayments";
    DocumentTypePath["MERCHANT_SERVICES_DEPOSITS"] = "merchantServicesDeposits";
    DocumentTypePath["ACCOUNTS_RECEIVABLE_COLLECTIONS"] = "accountsReceivableCollections";
    DocumentTypePath["VENDOR_REFUND"] = "vendorRefund";
    DocumentTypePath["TAX_REFUND_TO_BUSINESS"] = "taxRefundToBusiness";
    DocumentTypePath["OWNER_CONTRIBUTION"] = "ownerContribution";
    DocumentTypePath["PARTNER_CAPITAL_CONTRIBUTION"] = "partnerCapitalContribution";
    DocumentTypePath["BUSINESS_INSURANCE_CLAIM"] = "businessInsuranceClaim";
    // Tax-Related
    DocumentTypePath["FEDERAL_INCOME_TAX_REFUND"] = "federalIncomeTaxRefund";
    DocumentTypePath["STATE_INCOME_TAX_REFUND"] = "stateIncomeTaxRefund";
    DocumentTypePath["SALES_TAX_REFUND"] = "salesTaxRefund";
    DocumentTypePath["IRS_CREDIT_OR_REBATE"] = "irsCreditOrRebate";
    // Education
    DocumentTypePath["STUDENT_FINANCIAL_AID_REFUND"] = "studentFinancialAidRefund";
    DocumentTypePath["SCHOLARSHIP_REFUND"] = "scholarshipRefund";
    DocumentTypePath["GRANT_PROCEEDS"] = "grantProceeds";
    DocumentTypePath["TUITION_REIMBURSEMENT"] = "tuitionReimbursement";
    // Gambling & Gaming
    DocumentTypePath["CASINO_WINNINGS"] = "casinoWinnings";
    DocumentTypePath["LOTTERY_WINNINGS"] = "lotteryWinnings";
    DocumentTypePath["SPORTS_BETTING_WINNINGS"] = "sportsBettingWinnings";
    DocumentTypePath["POKER_TOURNAMENT_WINNINGS"] = "pokerTournamentWinnings";
    DocumentTypePath["SWEEPSTAKES_PRIZE"] = "sweepstakesPrize";
    // Online Platforms
    DocumentTypePath["PAYPAL_TRANSFER"] = "paypalTransfer";
    DocumentTypePath["VENMO_TRANSFER"] = "venmoTransfer";
    DocumentTypePath["CASH_APP_TRANSFER"] = "cashAppTransfer";
    DocumentTypePath["ZELLE_PAYMENT"] = "zellePayment";
    DocumentTypePath["STRIPE_PAYOUT"] = "stripePayout";
    DocumentTypePath["SQUARE_PAYOUT"] = "squarePayout";
    DocumentTypePath["ETSY_PAYOUT"] = "etsyPayout";
    DocumentTypePath["EBAY_PAYOUT"] = "ebayPayout";
    DocumentTypePath["AMAZON_SELLER_PAYOUT"] = "amazonSellerPayout";
    DocumentTypePath["AIRBNB_PAYOUT"] = "airbnbPayout";
    DocumentTypePath["VRBO_PAYOUT"] = "vrboPayout";
    DocumentTypePath["UBER_LYFT_EARNINGS"] = "uberLyftEarnings";
    DocumentTypePath["DOOR_DASH_INSTACART_EARNINGS"] = "doorDashInstacartEarnings";
    // Cash Deposits
    DocumentTypePath["PERSONAL_CASH_SAVINGS"] = "personalCashSavings";
    DocumentTypePath["CASH_FROM_BUSINESS_RECEIPTS"] = "cashFromBusinessReceipts";
    DocumentTypePath["CASH_GIFT"] = "cashGift";
    DocumentTypePath["CASH_FROM_SALE_OF_PERSONAL_PROPERTY"] = "cashFromSaleOfPersonalProperty";
    // Refunds & Credits
    DocumentTypePath["MERCHANT_REFUND"] = "merchantRefund";
    DocumentTypePath["CREDIT_CARD_REFUND"] = "creditCardRefund";
    DocumentTypePath["UTILITY_DEPOSIT_REFUND"] = "utilityDepositRefund";
    DocumentTypePath["WARRANTY_REIMBURSEMENT"] = "warrantyReimbursement";
    DocumentTypePath["MANUFACTURER_REBATE"] = "manufacturerRebate";
    // Miscellaneous
    DocumentTypePath["PRIZE_OR_AWARD"] = "prizeOrAward";
    DocumentTypePath["ROYALTIES"] = "royalties";
    DocumentTypePath["LICENSING_INCOME"] = "licensingIncome";
    DocumentTypePath["PATENT_INCOME"] = "patentIncome";
    DocumentTypePath["COPYRIGHT_INCOME"] = "copyrightIncome";
    DocumentTypePath["MINERAL_OR_OIL_RIGHTS_ROYALTIES"] = "mineralOrOilRightsRoyalties";
    DocumentTypePath["CROWDFUNDING_PROCEEDS"] = "crowdfundingProceeds";
    DocumentTypePath["CHARITABLE_GRANT"] = "charitableGrant";
    DocumentTypePath["CHURCH_ASSISTANCE"] = "churchAssistance";
    DocumentTypePath["DISASTER_RELIEF_FUNDS"] = "disasterReliefFunds";
    DocumentTypePath["FOREIGN_CURRENCY_EXCHANGE_PROCEEDS"] = "foreignCurrencyExchangeProceeds";
    // Post-notarization review requestable documents (see the matching DocumentUploadType members).
    DocumentTypePath["US_DRIVERS_LICENSE"] = "usDriversLicense";
    DocumentTypePath["US_STATE_ID_CARD"] = "usStateIdCard";
    DocumentTypePath["US_PASSPORT"] = "usPassport";
    DocumentTypePath["US_PASSPORT_CARD"] = "usPassportCard";
    DocumentTypePath["US_PERMANENT_RESIDENT_CARD"] = "usPermanentResidentCard";
    DocumentTypePath["TRIBAL_ID_CARD"] = "tribalIdCard";
    DocumentTypePath["US_DEPT_OF_STATE_DRIVERS_LICENSE"] = "usDeptOfStateDriversLicense";
    DocumentTypePath["US_EMPLOYMENT_AUTHORIZATION_CARD"] = "usEmploymentAuthorizationCard";
    DocumentTypePath["US_BIRTH_CERTIFICATE"] = "usBirthCertificate";
    DocumentTypePath["US_MILITARY_ID"] = "usMilitaryId";
    DocumentTypePath["GLOBAL_ENTRY_CARD"] = "globalEntryCard";
    DocumentTypePath["US_CERTIFICATE_OF_NATURALIZATION"] = "usCertificateOfNaturalization";
    DocumentTypePath["FOREIGN_PASSPORT"] = "foreignPassport";
    DocumentTypePath["STATE_DIGITAL_ID"] = "stateDigitalId";
    DocumentTypePath["ITIN_ASSIGNMENT_LETTER_CP565"] = "itinAssignmentLetterCp565";
    DocumentTypePath["PROPERTY_TAX_STATEMENT"] = "propertyTaxStatement";
    DocumentTypePath["LANDLORD_INSURANCE_POLICY"] = "landlordInsurancePolicy";
    DocumentTypePath["LEASE_AGREEMENT"] = "leaseAgreement";
    DocumentTypePath["MARRIAGE_CERTIFICATE"] = "marriageCertificate";
    DocumentTypePath["COURT_ORDER_NAME_CHANGE"] = "courtOrderNameChange";
    DocumentTypePath["FORM_1099_B"] = "form1099B";
    DocumentTypePath["POWER_OF_ATTORNEY"] = "powerOfAttorney";
    DocumentTypePath["IDENTITY_THEFT_WRITTEN_STATEMENT"] = "identityTheftWrittenStatement";
    DocumentTypePath["PERSONA_SESSION"] = "personaSession";
    DocumentTypePath["IDOLOGY_KBA"] = "idologyKba";
})(DocumentTypePath || (exports.DocumentTypePath = DocumentTypePath = {}));
// DocumentUploadTypes that correspond to a manual income-verification document a customer actually uploaded.
// This is the DocumentUploadType analog of MANUAL_VERIFICATION_DOCUMENT_TYPES (which is keyed on
// IncomeVerificationDocumentType, e.g. PAY_STUBS, whereas the document_upload.type column stores DocumentUploadType,
// e.g. PAY_STUB). SUPPORTING_DOCUMENT is intentionally excluded: it is a generic catch-all also used for
// non-document income sources (Plaid / Work Number / stated income), so it isn't a reliable income-document signal.
/** @TranslateToPython */
exports.MANUAL_INCOME_VERIFICATION_DOCUMENT_UPLOAD_TYPES = [
    DocumentUploadType.PAY_STUB,
    DocumentUploadType.W2,
    DocumentUploadType.TAX_RETURN,
    DocumentUploadType.STATE_TAX_RETURN,
    DocumentUploadType.BANK_STATEMENT,
    DocumentUploadType.FORM_1099,
    DocumentUploadType.PROFIT_AND_LOSS,
    DocumentUploadType.SOCIAL_SECURITY,
    DocumentUploadType.PENSION,
    DocumentUploadType.RETIREMENT,
];
// This set comprises of DocumentTypePaths that are user uploaded and pertain to income verification
exports.USER_UPLOADED_INCOME_VERIFICATION_DOCUMENT_TYPE_PATHS = new Set([
    DocumentTypePath.PAY_STUB,
    DocumentTypePath.W2,
    DocumentTypePath.TAX_RETURN,
    DocumentTypePath.STATE_TAX_RETURN,
    DocumentTypePath.BANK_STATEMENT,
    DocumentTypePath.FORM_1099,
    DocumentTypePath.PROFIT_AND_LOSS,
    DocumentTypePath.SOCIAL_SECURITY,
    DocumentTypePath.PENSION,
    DocumentTypePath.RETIREMENT,
    DocumentTypePath.OTHER_INCOME_LETTER,
    DocumentTypePath.SUPPORTING_DOCUMENT,
]);
/** @TranslateToPython */
exports.HUMAN_READABLE_NAME_FOR_DOCUMENT_UPLOAD_TYPE = {
    [DocumentUploadType.PAY_STUB]: 'Pay Stub',
    [DocumentUploadType.W2]: 'W2 form',
    [DocumentUploadType.TAX_RETURN]: 'Tax Return (1040)',
    [DocumentUploadType.STATE_TAX_RETURN]: 'State Tax Return',
    [DocumentUploadType.IRS_RECORD_OF_ACCOUNT]: 'IRS Record of Account',
    [DocumentUploadType.IRS_WAGE_AND_INCOME_TRANSCRIPT]: 'IRS Wage and Income Transcript',
    [DocumentUploadType.IRS_REJECTION_NOTICE]: 'IRS Rejection Notice',
    [DocumentUploadType.IRS_TAX_RETURN_TRANSCRIPT]: 'IRS Tax Return Transcript',
    [DocumentUploadType.BANK_STATEMENT]: 'Bank Statement',
    [DocumentUploadType.FORM_1099]: 'Form 1099',
    [DocumentUploadType.FORM_1099_R]: 'Form 1099 R',
    [DocumentUploadType.FORM_1099_SSA]: 'Form 1099 SSA',
    [DocumentUploadType.FORM_1099_MISC]: 'Form 1099 Misc',
    [DocumentUploadType.FORM_1099_NEC]: 'Form 1099 NEC',
    [DocumentUploadType.PROFIT_AND_LOSS]: 'Profit and Loss',
    [DocumentUploadType.SCHEDULE_C]: 'Schedule C',
    [DocumentUploadType.BENEFIT_LETTER]: 'Benefit Letter',
    [DocumentUploadType.OTHER_INCOME_LETTER]: 'Other Income Letter',
    [DocumentUploadType.BANK_STATEMENT_FOR_CASH_OUT]: 'Bank Statement',
    [DocumentUploadType.UTILITY_BILL]: 'Utility Bill',
    [DocumentUploadType.QUIT_CLAIM]: 'Quit Claim Deed',
    [DocumentUploadType.LAST_TRANSFER_DOCUMENT]: 'Last Transfer Document',
    [DocumentUploadType.GRANT_DEED]: 'Grant Deed',
    [DocumentUploadType.INTERSPOUSAL_TRANSFER]: 'Interspousal Transfer Deed',
    [DocumentUploadType.DEATH_CERTIFICATE]: 'Death Certificate',
    [DocumentUploadType.IDENTITY_DOCUMENT]: 'Identity Document',
    [DocumentUploadType.CARDHOLDER_AGREEMENT]: 'Cardholder Agreement',
    [DocumentUploadType.OFFER_CONTINGENCY_STATUS_DOCUMENT]: '',
    [DocumentUploadType.RECORDED_DEED_OF_TRUST]: 'Recorded Deed of Trust',
    [DocumentUploadType.RECORDED_TX_AFFIDAVIT]: 'Recorded TX Affidavit',
    [DocumentUploadType.STATES_TITLE_PACKAGE]: 'States Title Package',
    [DocumentUploadType.ACCOUNT_CLOSING_DOCUMENT]: 'Account Closing Document',
    [DocumentUploadType.INSURANCE_DOCUMENT]: 'Insurance Document',
    [DocumentUploadType.SUBORDINATION_DOCUMENT]: 'Subordination Document',
    [DocumentUploadType.DEED_OF_TRUST_AMENDMENT]: 'Deed of Trust Amendment',
    [DocumentUploadType.MORTGAGE_DOCUMENT]: 'Mortgage Document',
    [DocumentUploadType.VOIDED_CHECK]: 'Voided Check',
    [DocumentUploadType.OFAC]: 'OFAC Document',
    [DocumentUploadType.SUPPORTING_DOCUMENT]: 'Supporting Document',
    [DocumentUploadType.PHONE_BILL]: 'Phone Bill',
    [DocumentUploadType.FLOOD_INSURANCE_DOCUMENT]: 'Flood Insurance Document',
    [DocumentUploadType.AUTO_INSURANCE_DOCUMENT]: 'Auto Insurance Document',
    [DocumentUploadType.TITLE_INSURANCE_DOCUMENT]: 'Title Insurance Document',
    [DocumentUploadType.HOMEOWNERS_INSURANCE_DOCUMENT]: 'Homeowners Insurance Document',
    [DocumentUploadType.CONDO_HOA_DOCUMENT]: 'Condo Homeowners Insurance Document',
    [DocumentUploadType.DISPUTE_PROVIDER_DATA_DOCUMENT]: 'Dispute Provider Data Document',
    [DocumentUploadType.SCANNED_RIN_DOCUMENT]: 'Scanned RIN Document',
    [DocumentUploadType.TRANSACTION_DISPUTE_SUPPORTING_DOCUMENT]: 'Transaction Dispute Supporting Document',
    [DocumentUploadType.FAST_FUNDING_VIDEO]: 'Fast Funding Video',
    [DocumentUploadType.FINAL_TITLE_INSURANCE_POLICY]: 'Title Insurance Policy',
    [DocumentUploadType.TITLE_INSURANCE_PRELIMINARY_REPORT]: 'Title Insurance Preliminary Report',
    [DocumentUploadType.LEGAL_DESCRIPTION]: 'Legal Description',
    [DocumentUploadType.DISPUTE_CO_OWNER_DOCUMENT]: 'Dispute Coowner Document',
    [DocumentUploadType.SOCIAL_SECURITY_CARD_TAX_TRANSCRIPT_1040_RETURN_RECEIPT]: 'Social Security Card, Tax Transcript, or 1040 with Return Receipt',
    [DocumentUploadType.SOCIAL_SECURITY_CARD]: 'Social Security Card',
    [DocumentUploadType.SECOND_FORM_OF_GOVERNMENT_ISSUED_ID]: 'second form of government issued ID',
    [DocumentUploadType.DIVORCE_DECREE]: 'Divorce Decree',
    [DocumentUploadType.WARRANTY_DEED]: 'Warranty Deed',
    [DocumentUploadType.VOICE_VERIFICATION]: 'Voice Verification',
    [DocumentUploadType.RECORDED_RECONVEYANCE]: 'Recorded Reconveyance',
    [DocumentUploadType.COMPETITOR_AGREEMENT]: 'Competitor Agreement',
    [DocumentUploadType.COMPETITOR_AGREEMENT_V2]: 'Competitor Agreement',
    [DocumentUploadType.MORTGAGE_STATEMENT]: 'Mortgage Statement',
    [DocumentUploadType.AVEN_SIGNING_DOCUMENT]: 'Aven Signing Document',
    [DocumentUploadType.AVEN_SIGNED_DOCUMENT]: 'Aven Signed Document',
    [DocumentUploadType.CREATOR_CHALLENGE_VIDEO]: 'Creator Challenge Video',
    [DocumentUploadType.SOCIAL_SECURITY]: 'Social Security Statement or Social Security Award Letter',
    [DocumentUploadType.PENSION]: 'Pension Statement',
    [DocumentUploadType.RETIREMENT]: 'IRA Distribution or 401K Distribution Statement',
    [DocumentUploadType.PRIOR_HELOC_STATEMENT]: 'Prior HELOC Statement',
    [DocumentUploadType.FIRST_LIEN_MORTGAGE_STATEMENT]: 'First Lien Mortgage Statement',
    [DocumentUploadType.MULTI_LIEN_REFI_MORTGAGE_STATEMENT]: 'Mortgage Statement',
    [DocumentUploadType.VERIFY_CURRENT_RENT_BANK_STATEMENT]: 'Bank Statement',
    [DocumentUploadType.VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT]: 'Property Management Statement',
    [DocumentUploadType.FIRST_LIEN_DOC]: 'Mortgage Statement',
    [DocumentUploadType.ALL_LIEN_DOC]: 'Lien Status Document',
    [DocumentUploadType.HELOC_REFI_PAYOFF_QUOTE]: 'HELOC Refinance Payoff Quote',
    [DocumentUploadType.BANK_STATEMENT_ASSET_VERIFICATION]: 'Bank Statements',
    [DocumentUploadType.AVEN_ACCOUNT_TERMINATION_LETTER]: 'Aven Account Termination Letter',
    [DocumentUploadType.BANKRUPTCY_DOCUMENT]: 'Bankruptcy Document',
    [DocumentUploadType.FORECLOSURE_SOT]: 'Foreclosure SOT',
    [DocumentUploadType.FORECLOSURE_NOD]: 'Foreclosure NOD',
    [DocumentUploadType.FORECLOSURE_OTHER]: 'Foreclosure Other',
    [DocumentUploadType.FORECLOSURE_TSG]: 'Foreclosure TSG',
    [DocumentUploadType.MANUAL_PAYOFF_QUOTE]: 'Payoff Quote',
    [DocumentUploadType.QUALIFIED_WRITTEN_REQUEST]: 'Qualified Written Request',
    [DocumentUploadType.DEBT_VALIDATION_LETTER_RESPONSE]: 'Debt Validation Letter Response',
    [DocumentUploadType.STATEMENT_RESERVES_VERIFICATION]: 'Statement Reserves Verification',
    [DocumentUploadType.BROKERAGE_STATEMENT_ASSET_VERIFICATION]: 'Brokerage Statements',
    [DocumentUploadType.HELOC_REFI_LENDER_CONFIRMATION_OF_FUNDS_RECEIVED]: 'HELOC Refinance Lender Confirmation of Funds Received',
    [DocumentUploadType.HELOC_REFI_PAID_IN_FULL_LETTER]: 'HELOC Refinance Paid In Full Letter',
    [DocumentUploadType.HELOC_REFI_SATISFACTION_OF_MORTGAGE]: 'HELOC Refinance Satisfaction of Mortgage',
    [DocumentUploadType.HELOC_REFI_RECORDED_RECONVEYANCE]: 'HELOC Refinance Recorded Reconveyance',
    [DocumentUploadType.HELOC_REFI_SIGNED_BORROWER_AUTH]: 'HELOC Refinance Signed Borrower Authorization',
    [DocumentUploadType.TITLE_INSURANCE_CLOSING_PACKAGE]: 'Title Insurance Commitment',
    [DocumentUploadType.CLOSING_PACKAGE_ATTORNEY_APPROVAL]: 'Closing Package Attorney Approval',
    [DocumentUploadType.MORTGAGE_LAW_RETURN_DOCUMENT]: 'Mortgage Law Return Document',
    [DocumentUploadType.TITLE_INSURANCE_VESTING_DEED]: 'Title Insurance Vesting Deed',
    [DocumentUploadType.TITLE_INSURANCE_TAX_CERTIFICATE]: 'Title Insurance Tax Certificate',
    [DocumentUploadType.STATEMENT_OF_INFORMATION]: 'Statement of Information',
    [DocumentUploadType.THIRD_PARTY_LEAD_TRANSFER_DEED]: 'Third Party Lead Transfer Deed',
    [DocumentUploadType.THIRD_PARTY_LEAD_IDENTITY_DOCUMENT]: 'Third Party Lead Identity Document',
    [DocumentUploadType.STATE_CLOSING_DOCUMENT]: 'State Closing Document',
    [DocumentUploadType.APPRAISAL_REPORT]: 'Appraisal Report',
    [DocumentUploadType.BALANCE_TRANSFER_SAVINGS_GUARANTEE_APR_VERIFICATION]: 'Balance Transfer Savings Guarantee APR Verification',
    [DocumentUploadType.ARB_OPT_OUT]: 'Arbitration Opt Out',
    [DocumentUploadType.CIP_EVIDENCE]: 'CIP Evidence',
    [DocumentUploadType.IDOLOGY_REPORT]: 'IDology Report',
    [DocumentUploadType.MERCHANT_CONTRACT]: 'Contract',
    [DocumentUploadType.MERCHANT_WORK_ORDER]: 'Work Order',
    [DocumentUploadType.MERCHANT_ADDENDUM]: 'Addendum',
    [DocumentUploadType.MERCHANT_COMPLETION_CERTIFICATE]: 'Completion Certificate',
    [DocumentUploadType.MERCHANT_JOB_PHOTO]: 'Job Photo',
    [DocumentUploadType.MERCHANT_OTHER]: 'Other',
    [DocumentUploadType.BUSINESS_ARTICLES_OF_ORGANIZATION]: 'Business Articles of Organization',
    [DocumentUploadType.BUSINESS_CERTIFICATE_OF_GOOD_STANDING]: 'Business Certificate of Good Standing',
    [DocumentUploadType.BUSINESS_OWNERSHIP_CERTIFICATION_OR_OPERATING_AGREEMENT]: 'Business Ownership Certification or Operating Agreement',
    [DocumentUploadType.BUSINESS_OWNERSHIP_TAX_RETURN]: 'Business Ownership Tax Return',
    [DocumentUploadType.BUSINESS_OWNERSHIP_INCOME_DOC]: 'Business Ownership Income Document',
    [DocumentUploadType.DEPOSIT_RECEIPT]: 'Deposit Receipt',
    [DocumentUploadType.WIRE_CONFIRMATION]: 'Wire Confirmation',
    [DocumentUploadType.GIFT_LETTER]: 'Gift Letter',
    [DocumentUploadType.BILL_OF_SALE]: 'Bill of Sale',
    [DocumentUploadType.SETTLEMENT_STATEMENT]: 'Settlement Statement',
    [DocumentUploadType.ESCROW_STATEMENT]: 'Escrow Statement',
    [DocumentUploadType.BROKERAGE_STATEMENT]: 'Brokerage Statement',
    [DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT]: 'Retirement Account Statement',
    [DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION]: 'Insurance Claim Documentation',
    [DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS]: 'Court Settlement Documents',
    [DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS]: 'Trust or Estate Documents',
    [DocumentUploadType.CERTIFICATE_OF_TRUST]: 'Certificate of Trust',
    [DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE]: 'Loan Agreement or Promissory Note',
    [DocumentUploadType.INHERITANCE_DOCUMENTATION]: 'Inheritance Documentation',
    [DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT]: 'Invoice and Proof of Payment',
    [DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS]: 'Business Financial Statements',
    // Employment & Income
    [DocumentUploadType.PAYROLL_DIRECT_DEPOSIT]: 'Payroll Direct Deposit',
    [DocumentUploadType.BONUS]: 'Bonus',
    [DocumentUploadType.COMMISSION]: 'Commission',
    [DocumentUploadType.OVERTIME_PAY]: 'Overtime Pay',
    [DocumentUploadType.TIPS]: 'Tips',
    [DocumentUploadType.SEVERANCE_PAY]: 'Severance Pay',
    [DocumentUploadType.PTO_PAY_OUT]: 'PTO Pay Out',
    [DocumentUploadType.EXPENSE_REIMBURSEMENT]: 'Expense Reimbursement',
    [DocumentUploadType.INDEPENDENT_CONTRACTOR_INCOME]: 'Independent Contractor Income',
    [DocumentUploadType.SELF_EMPLOYMENT_BUSINESS_INCOME]: 'Self Employment Business Income',
    // Retirement & Government Benefits
    [DocumentUploadType.SOCIAL_SECURITY_RETIREMENT]: 'Social Security Retirement',
    [DocumentUploadType.SOCIAL_SECURITY_DISABILITY]: 'Social Security Disability',
    [DocumentUploadType.SUPPLEMENTAL_SECURITY_INCOME]: 'Supplemental Security Income',
    [DocumentUploadType.ANNUITY_PAYMENTS]: 'Annuity Payments',
    [DocumentUploadType.VETERANS_BENEFITS]: 'Veterans Benefits',
    [DocumentUploadType.RAILROAD_RETIREMENT]: 'Railroad Retirement',
    [DocumentUploadType.STATE_RETIREMENT_BENEFITS]: 'State Retirement Benefits',
    [DocumentUploadType.MILITARY_RETIREMENT]: 'Military Retirement',
    // Transfers
    [DocumentUploadType.TRANSFER_FROM_PERSONAL_ACCOUNT]: 'Transfer From Personal Account',
    [DocumentUploadType.TRANSFER_FROM_JOINT_ACCOUNT]: 'Transfer From Joint Account',
    [DocumentUploadType.BROKERAGE_ACCOUNT_TRANSFER]: 'Brokerage Account Transfer',
    [DocumentUploadType.SAVINGS_ACCOUNT_TRANSFER]: 'Savings Account Transfer',
    [DocumentUploadType.CREDIT_UNION_TRANSFER]: 'Credit Union Transfer',
    [DocumentUploadType.MONEY_MARKET_TRANSFER]: 'Money Market Transfer',
    [DocumentUploadType.TRUST_ACCOUNT_TRANSFER]: 'Trust Account Transfer',
    [DocumentUploadType.CD_MATURITY_PROCEEDS]: 'CD Maturity Proceeds',
    [DocumentUploadType.INTERNATIONAL_WIRE_TRANSFER]: 'International Wire Transfer',
    [DocumentUploadType.INTERNAL_BANK_TRANSFER]: 'Internal Bank Transfer',
    // Sale of Assets
    [DocumentUploadType.SALE_OF_HOME]: 'Sale Of Home',
    [DocumentUploadType.SALE_OF_LAND]: 'Sale Of Land',
    [DocumentUploadType.SALE_OF_VEHICLE]: 'Sale Of Vehicle',
    [DocumentUploadType.SALE_OF_BOAT]: 'Sale Of Boat',
    [DocumentUploadType.SALE_OF_RV]: 'Sale Of RV',
    [DocumentUploadType.SALE_OF_MOTORCYCLE]: 'Sale Of Motorcycle',
    [DocumentUploadType.SALE_OF_BUSINESS]: 'Sale Of Business',
    [DocumentUploadType.SALE_OF_STOCKS]: 'Sale Of Stocks',
    [DocumentUploadType.SALE_OF_BONDS]: 'Sale Of Bonds',
    [DocumentUploadType.SALE_OF_MUTUAL_FUNDS]: 'Sale Of Mutual Funds',
    [DocumentUploadType.SALE_OF_CRYPTOCURRENCY]: 'Sale Of Cryptocurrency',
    [DocumentUploadType.SALE_OF_COLLECTIBLES]: 'Sale Of Collectibles',
    [DocumentUploadType.ESTATE_SALE_PROCEEDS]: 'Estate Sale Proceeds',
    // Investments
    [DocumentUploadType.STOCK_DIVIDENDS]: 'Stock Dividends',
    [DocumentUploadType.BOND_INTEREST]: 'Bond Interest',
    [DocumentUploadType.MUTUAL_FUND_DISTRIBUTION]: 'Mutual Fund Distribution',
    [DocumentUploadType.CAPITAL_GAINS_DISTRIBUTION]: 'Capital Gains Distribution',
    [DocumentUploadType.INVESTMENT_ACCOUNT_WITHDRAWAL]: 'Investment Account Withdrawal',
    [DocumentUploadType.RETIREMENT_ACCOUNT_DISTRIBUTION]: 'Retirement Account Distribution',
    [DocumentUploadType.REQUIRED_MINIMUM_DISTRIBUTION]: 'Required Minimum Distribution',
    // Insurance
    [DocumentUploadType.LIFE_INSURANCE_PAYOUT]: 'Life Insurance Payout',
    [DocumentUploadType.HEALTH_INSURANCE_REIMBURSEMENT]: 'Health Insurance Reimbursement',
    [DocumentUploadType.AUTO_INSURANCE_CLAIM]: 'Auto Insurance Claim',
    [DocumentUploadType.HOMEOWNERS_INSURANCE_CLAIM]: 'Homeowners Insurance Claim',
    [DocumentUploadType.DISABILITY_INSURANCE_BENEFITS]: 'Disability Insurance Benefits',
    [DocumentUploadType.LONG_TERM_CARE_INSURANCE_PAYOUT]: 'Long Term Care Insurance Payout',
    // Real Estate
    [DocumentUploadType.RENTAL_INCOME]: 'Rental Income',
    [DocumentUploadType.SECURITY_DEPOSIT_REFUND]: 'Security Deposit Refund',
    [DocumentUploadType.ESCROW_REFUND]: 'Escrow Refund',
    [DocumentUploadType.PROPERTY_TAX_REFUND]: 'Property Tax Refund',
    [DocumentUploadType.MORTGAGE_ESCROW_SURPLUS]: 'Mortgage Escrow Surplus',
    [DocumentUploadType.HOME_EQUITY_LOAN_PROCEEDS]: 'Home Equity Loan Proceeds',
    [DocumentUploadType.HELOC_ADVANCE]: 'HELOC Advance',
    [DocumentUploadType.CASH_OUT_REFINANCE_PROCEEDS]: 'Cash Out Refinance Proceeds',
    [DocumentUploadType.HOME_SALE_PROCEEDS]: 'Home Sale Proceeds',
    // Loans
    [DocumentUploadType.PERSONAL_LOAN_PROCEEDS]: 'Personal Loan Proceeds',
    [DocumentUploadType.AUTO_LOAN_PROCEEDS]: 'Auto Loan Proceeds',
    [DocumentUploadType.STUDENT_LOAN_DISBURSEMENT]: 'Student Loan Disbursement',
    [DocumentUploadType.BUSINESS_LOAN_PROCEEDS]: 'Business Loan Proceeds',
    [DocumentUploadType.SBA_LOAN_PROCEEDS]: 'SBA Loan Proceeds',
    [DocumentUploadType.CONSTRUCTION_LOAN_DRAW]: 'Construction Loan Draw',
    [DocumentUploadType.PRIVATE_LOAN_FROM_FAMILY_FRIEND]: 'Private Loan From Family Friend',
    [DocumentUploadType.MARGIN_LOAN]: 'Margin Loan',
    [DocumentUploadType.LINE_OF_CREDIT_ADVANCE]: 'Line Of Credit Advance',
    // Gifts & Family
    [DocumentUploadType.GIFT_FROM_FAMILY_MEMBER]: 'Gift From Family Member',
    [DocumentUploadType.GIFT_FROM_FRIEND]: 'Gift From Friend',
    [DocumentUploadType.WEDDING_GIFT]: 'Wedding Gift',
    [DocumentUploadType.GRADUATION_GIFT]: 'Graduation Gift',
    [DocumentUploadType.BIRTHDAY_GIFT]: 'Birthday Gift',
    [DocumentUploadType.INHERITANCE]: 'Inheritance',
    [DocumentUploadType.TRUST_DISTRIBUTION]: 'Trust Distribution',
    // Legal & Settlement
    [DocumentUploadType.LAWSUIT_SETTLEMENT]: 'Lawsuit Settlement',
    [DocumentUploadType.CLASS_ACTION_SETTLEMENT]: 'Class Action Settlement',
    [DocumentUploadType.WORKERS_COMPENSATION_SETTLEMENT]: 'Workers Compensation Settlement',
    [DocumentUploadType.PERSONAL_INJURY_SETTLEMENT]: 'Personal Injury Settlement',
    [DocumentUploadType.DIVORCE_SETTLEMENT]: 'Divorce Settlement',
    [DocumentUploadType.CHILD_SUPPORT_PAYMENT]: 'Child Support Payment',
    [DocumentUploadType.ALIMONY]: 'Alimony',
    [DocumentUploadType.ESTATE_DISTRIBUTION]: 'Estate Distribution',
    // Business
    [DocumentUploadType.CUSTOMER_PAYMENTS]: 'Customer Payments',
    [DocumentUploadType.MERCHANT_SERVICES_DEPOSITS]: 'Merchant Services Deposits',
    [DocumentUploadType.ACCOUNTS_RECEIVABLE_COLLECTIONS]: 'Accounts Receivable Collections',
    [DocumentUploadType.VENDOR_REFUND]: 'Vendor Refund',
    [DocumentUploadType.TAX_REFUND_TO_BUSINESS]: 'Tax Refund To Business',
    [DocumentUploadType.OWNER_CONTRIBUTION]: 'Owner Contribution',
    [DocumentUploadType.PARTNER_CAPITAL_CONTRIBUTION]: 'Partner Capital Contribution',
    [DocumentUploadType.BUSINESS_INSURANCE_CLAIM]: 'Business Insurance Claim',
    // Tax-Related
    [DocumentUploadType.FEDERAL_INCOME_TAX_REFUND]: 'Federal Income Tax Refund',
    [DocumentUploadType.STATE_INCOME_TAX_REFUND]: 'State Income Tax Refund',
    [DocumentUploadType.SALES_TAX_REFUND]: 'Sales Tax Refund',
    [DocumentUploadType.IRS_CREDIT_OR_REBATE]: 'IRS Credit Or Rebate',
    // Education
    [DocumentUploadType.STUDENT_FINANCIAL_AID_REFUND]: 'Student Financial Aid Refund',
    [DocumentUploadType.SCHOLARSHIP_REFUND]: 'Scholarship Refund',
    [DocumentUploadType.GRANT_PROCEEDS]: 'Grant Proceeds',
    [DocumentUploadType.TUITION_REIMBURSEMENT]: 'Tuition Reimbursement',
    // Gambling & Gaming
    [DocumentUploadType.CASINO_WINNINGS]: 'Casino Winnings',
    [DocumentUploadType.LOTTERY_WINNINGS]: 'Lottery Winnings',
    [DocumentUploadType.SPORTS_BETTING_WINNINGS]: 'Sports Betting Winnings',
    [DocumentUploadType.POKER_TOURNAMENT_WINNINGS]: 'Poker Tournament Winnings',
    [DocumentUploadType.SWEEPSTAKES_PRIZE]: 'Sweepstakes Prize',
    // Online Platforms
    [DocumentUploadType.PAYPAL_TRANSFER]: 'PayPal Transfer',
    [DocumentUploadType.VENMO_TRANSFER]: 'Venmo Transfer',
    [DocumentUploadType.CASH_APP_TRANSFER]: 'Cash App Transfer',
    [DocumentUploadType.ZELLE_PAYMENT]: 'Zelle Payment',
    [DocumentUploadType.STRIPE_PAYOUT]: 'Stripe Payout',
    [DocumentUploadType.SQUARE_PAYOUT]: 'Square Payout',
    [DocumentUploadType.ETSY_PAYOUT]: 'Etsy Payout',
    [DocumentUploadType.EBAY_PAYOUT]: 'Ebay Payout',
    [DocumentUploadType.AMAZON_SELLER_PAYOUT]: 'Amazon Seller Payout',
    [DocumentUploadType.AIRBNB_PAYOUT]: 'Airbnb Payout',
    [DocumentUploadType.VRBO_PAYOUT]: 'Vrbo Payout',
    [DocumentUploadType.UBER_LYFT_EARNINGS]: 'Uber Lyft Earnings',
    [DocumentUploadType.DOOR_DASH_INSTACART_EARNINGS]: 'Door Dash Instacart Earnings',
    // Cash Deposits
    [DocumentUploadType.PERSONAL_CASH_SAVINGS]: 'Personal Cash Savings',
    [DocumentUploadType.CASH_FROM_BUSINESS_RECEIPTS]: 'Cash From Business Receipts',
    [DocumentUploadType.CASH_GIFT]: 'Cash Gift',
    [DocumentUploadType.CASH_FROM_SALE_OF_PERSONAL_PROPERTY]: 'Cash From Sale Of Personal Property',
    // Refunds & Credits
    [DocumentUploadType.MERCHANT_REFUND]: 'Merchant Refund',
    [DocumentUploadType.CREDIT_CARD_REFUND]: 'Credit Card Refund',
    [DocumentUploadType.UTILITY_DEPOSIT_REFUND]: 'Utility Deposit Refund',
    [DocumentUploadType.WARRANTY_REIMBURSEMENT]: 'Warranty Reimbursement',
    [DocumentUploadType.MANUFACTURER_REBATE]: 'Manufacturer Rebate',
    // Miscellaneous
    [DocumentUploadType.PRIZE_OR_AWARD]: 'Prize Or Award',
    [DocumentUploadType.ROYALTIES]: 'Royalties',
    [DocumentUploadType.LICENSING_INCOME]: 'Licensing Income',
    [DocumentUploadType.PATENT_INCOME]: 'Patent Income',
    [DocumentUploadType.COPYRIGHT_INCOME]: 'Copyright Income',
    [DocumentUploadType.MINERAL_OR_OIL_RIGHTS_ROYALTIES]: 'Mineral Or Oil Rights Royalties',
    [DocumentUploadType.CROWDFUNDING_PROCEEDS]: 'Crowdfunding Proceeds',
    [DocumentUploadType.CHARITABLE_GRANT]: 'Charitable Grant',
    [DocumentUploadType.CHURCH_ASSISTANCE]: 'Church Assistance',
    [DocumentUploadType.DISASTER_RELIEF_FUNDS]: 'Disaster Relief Funds',
    [DocumentUploadType.FOREIGN_CURRENCY_EXCHANGE_PROCEEDS]: 'Foreign Currency Exchange Proceeds',
    [DocumentUploadType.US_DRIVERS_LICENSE]: "US Driver's License",
    [DocumentUploadType.US_STATE_ID_CARD]: 'US State ID Card',
    [DocumentUploadType.US_PASSPORT]: 'US Passport',
    [DocumentUploadType.US_PASSPORT_CARD]: 'US Passport Card',
    [DocumentUploadType.US_PERMANENT_RESIDENT_CARD]: 'US Permanent Resident Card',
    [DocumentUploadType.TRIBAL_ID_CARD]: 'Tribal ID Card',
    [DocumentUploadType.US_DEPT_OF_STATE_DRIVERS_LICENSE]: "US Dept. of State Driver's License",
    [DocumentUploadType.US_EMPLOYMENT_AUTHORIZATION_CARD]: 'US Employment Authorization Card',
    [DocumentUploadType.US_BIRTH_CERTIFICATE]: 'US Birth Certificate',
    [DocumentUploadType.US_MILITARY_ID]: 'US Military ID',
    [DocumentUploadType.GLOBAL_ENTRY_CARD]: 'Global Entry Card',
    [DocumentUploadType.US_CERTIFICATE_OF_NATURALIZATION]: 'US Certificate of Naturalization',
    [DocumentUploadType.FOREIGN_PASSPORT]: 'Foreign Passport',
    [DocumentUploadType.STATE_DIGITAL_ID]: 'State Digital ID',
    [DocumentUploadType.ITIN_ASSIGNMENT_LETTER_CP565]: 'ITIN Assignment Letter (CP565)',
    [DocumentUploadType.PROPERTY_TAX_STATEMENT]: 'Property Tax Statement',
    [DocumentUploadType.LANDLORD_INSURANCE_POLICY]: 'Landlord Insurance Policy',
    [DocumentUploadType.LEASE_AGREEMENT]: 'Lease Agreement',
    [DocumentUploadType.MARRIAGE_CERTIFICATE]: 'Marriage Certificate',
    [DocumentUploadType.COURT_ORDER_NAME_CHANGE]: 'Court Order for Name Change',
    [DocumentUploadType.FORM_1099_B]: 'Form 1099-B',
    [DocumentUploadType.POWER_OF_ATTORNEY]: 'Power of Attorney',
    [DocumentUploadType.IDENTITY_THEFT_WRITTEN_STATEMENT]: 'Identity Theft Written Statement',
    [DocumentUploadType.PERSONA_SESSION]: 'Identity Verification (Persona)',
    [DocumentUploadType.IDOLOGY_KBA]: 'Knowledge-Based Authentication (IDology)',
};
// DocumentUploadTypes fulfilled by completing an action — an identity-verification session (Persona),
// knowledge-based authentication (IDology), or a voice/phone verification — rather than uploading a file.
// Used to drive upload-vs-action copy in the borrower UI and comms for post-notarization-review requests,
// so the distinction lives here rather than as a per-request attribute.
exports.NON_UPLOAD_DOCUMENT_UPLOAD_TYPES = new Set([DocumentUploadType.PERSONA_SESSION, DocumentUploadType.IDOLOGY_KBA, DocumentUploadType.VOICE_VERIFICATION]);
const documentUploadTypeRequiresUpload = (documentUploadType) => !exports.NON_UPLOAD_DOCUMENT_UPLOAD_TYPES.has(documentUploadType);
exports.documentUploadTypeRequiresUpload = documentUploadTypeRequiresUpload;
exports.documentTypeForPath = {
    [DocumentTypePath.BANK_STATEMENT]: DocumentUploadType.BANK_STATEMENT,
    [DocumentTypePath.FORM_1099]: DocumentUploadType.FORM_1099,
    [DocumentTypePath.PAY_STUB]: DocumentUploadType.PAY_STUB,
    [DocumentTypePath.TAX_RETURN]: DocumentUploadType.TAX_RETURN,
    [DocumentTypePath.STATE_TAX_RETURN]: DocumentUploadType.STATE_TAX_RETURN,
    [DocumentTypePath.IRS_RECORD_OF_ACCOUNT]: DocumentUploadType.IRS_RECORD_OF_ACCOUNT,
    [DocumentTypePath.IRS_WAGE_AND_INCOME_TRANSCRIPT]: DocumentUploadType.IRS_WAGE_AND_INCOME_TRANSCRIPT,
    [DocumentTypePath.IRS_REJECTION_NOTICE]: DocumentUploadType.IRS_REJECTION_NOTICE,
    [DocumentTypePath.IRS_TAX_RETURN_TRANSCRIPT]: DocumentUploadType.IRS_TAX_RETURN_TRANSCRIPT,
    [DocumentTypePath.W2]: DocumentUploadType.W2,
    [DocumentTypePath.BENEFIT_LETTER]: DocumentUploadType.BENEFIT_LETTER,
    [DocumentTypePath.OTHER_INCOME_LETTER]: DocumentUploadType.OTHER_INCOME_LETTER,
    [DocumentTypePath.BANK_STATEMENT_FOR_CASH_OUT]: DocumentUploadType.BANK_STATEMENT_FOR_CASH_OUT,
    [DocumentTypePath.UTILITY_BILL]: DocumentUploadType.UTILITY_BILL,
    [DocumentTypePath.QUIT_CLAIM]: DocumentUploadType.QUIT_CLAIM,
    [DocumentTypePath.LAST_TRANSFER_DOCUMENT]: DocumentUploadType.LAST_TRANSFER_DOCUMENT,
    [DocumentTypePath.GRANT_DEED]: DocumentUploadType.GRANT_DEED,
    [DocumentTypePath.INTERSPOUSAL_TRANSFER]: DocumentUploadType.INTERSPOUSAL_TRANSFER,
    [DocumentTypePath.DEATH_CERTIFICATE]: DocumentUploadType.DEATH_CERTIFICATE,
    [DocumentTypePath.VOICE_VERIFICATION]: DocumentUploadType.VOICE_VERIFICATION,
    [DocumentTypePath.IDENTITY_DOCUMENT]: DocumentUploadType.IDENTITY_DOCUMENT,
    [DocumentTypePath.CARDHOLDER_AGREEMENT]: DocumentUploadType.CARDHOLDER_AGREEMENT,
    [DocumentTypePath.OFFER_CONTINGENCY_STATUS_DOCUMENT]: DocumentUploadType.OFFER_CONTINGENCY_STATUS_DOCUMENT,
    [DocumentTypePath.RECORDED_DEED_OF_TRUST]: DocumentUploadType.RECORDED_DEED_OF_TRUST,
    [DocumentTypePath.RECORDED_TX_AFFIDAVIT]: DocumentUploadType.RECORDED_TX_AFFIDAVIT,
    [DocumentTypePath.STATES_TITLE_PACKAGE]: DocumentUploadType.STATES_TITLE_PACKAGE,
    [DocumentTypePath.ACCOUNT_CLOSING_DOCUMENT]: DocumentUploadType.ACCOUNT_CLOSING_DOCUMENT,
    [DocumentTypePath.INSURANCE_DOCUMENT]: DocumentUploadType.INSURANCE_DOCUMENT,
    [DocumentTypePath.SUBORDINATION_DOCUMENT]: DocumentUploadType.SUBORDINATION_DOCUMENT,
    [DocumentTypePath.DEED_OF_TRUST_AMENDMENT]: DocumentUploadType.DEED_OF_TRUST_AMENDMENT,
    [DocumentTypePath.MORTGAGE_DOCUMENT]: DocumentUploadType.MORTGAGE_DOCUMENT,
    [DocumentTypePath.VOIDED_CHECK]: DocumentUploadType.VOIDED_CHECK,
    [DocumentTypePath.OFAC]: DocumentUploadType.OFAC,
    [DocumentTypePath.SUPPORTING_DOCUMENT]: DocumentUploadType.SUPPORTING_DOCUMENT,
    [DocumentTypePath.PHONE_BILL]: DocumentUploadType.PHONE_BILL,
    [DocumentTypePath.FLOOD_INSURANCE_DOCUMENT]: DocumentUploadType.FLOOD_INSURANCE_DOCUMENT,
    [DocumentTypePath.AUTO_INSURANCE_DOCUMENT]: DocumentUploadType.AUTO_INSURANCE_DOCUMENT,
    [DocumentTypePath.TITLE_INSURANCE_DOCUMENT]: DocumentUploadType.TITLE_INSURANCE_DOCUMENT,
    [DocumentTypePath.HOMEOWNERS_INSURANCE_DOCUMENT]: DocumentUploadType.HOMEOWNERS_INSURANCE_DOCUMENT,
    [DocumentTypePath.CONDO_HOA_DOCUMENT]: DocumentUploadType.CONDO_HOA_DOCUMENT,
    [DocumentTypePath.DISPUTE_PROVIDER_DATA_DOCUMENT]: DocumentUploadType.DISPUTE_PROVIDER_DATA_DOCUMENT,
    [DocumentTypePath.SCANNED_RIN_DOCUMENT]: DocumentUploadType.SCANNED_RIN_DOCUMENT,
    [DocumentTypePath.TRANSACTION_DISPUTE_SUPPORTING_DOCUMENT]: DocumentUploadType.TRANSACTION_DISPUTE_SUPPORTING_DOCUMENT,
    [DocumentTypePath.FAST_FUNDING_VIDEO]: DocumentUploadType.FAST_FUNDING_VIDEO,
    [DocumentTypePath.FINAL_TITLE_INSURANCE_POLICY]: DocumentUploadType.FINAL_TITLE_INSURANCE_POLICY,
    [DocumentTypePath.TITLE_INSURANCE_PRELIMINARY_REPORT]: DocumentUploadType.TITLE_INSURANCE_PRELIMINARY_REPORT,
    [DocumentTypePath.LEGAL_DESCRIPTION]: DocumentUploadType.LEGAL_DESCRIPTION,
    [DocumentTypePath.DISPUTE_CO_OWNER_DOCUMENT]: DocumentUploadType.DISPUTE_CO_OWNER_DOCUMENT,
    [DocumentTypePath.SOCIAL_SECURITY_CARD_TAX_TRANSCRIPT_1040_RETURN_RECEIPT]: DocumentUploadType.SOCIAL_SECURITY_CARD_TAX_TRANSCRIPT_1040_RETURN_RECEIPT,
    [DocumentTypePath.SOCIAL_SECURITY_CARD]: DocumentUploadType.SOCIAL_SECURITY_CARD,
    [DocumentTypePath.SECOND_FORM_OF_GOVERNMENT_ISSUED_ID]: DocumentUploadType.SECOND_FORM_OF_GOVERNMENT_ISSUED_ID,
    [DocumentTypePath.DIVORCE_DECREE]: DocumentUploadType.DIVORCE_DECREE,
    [DocumentTypePath.WARRANTY_DEED]: DocumentUploadType.WARRANTY_DEED,
    [DocumentTypePath.RECORDED_RECONVEYANCE]: DocumentUploadType.RECORDED_RECONVEYANCE,
    [DocumentTypePath.COMPETITOR_AGREEMENT]: DocumentUploadType.COMPETITOR_AGREEMENT,
    [DocumentTypePath.COMPETITOR_AGREEMENT_V2]: DocumentUploadType.COMPETITOR_AGREEMENT_V2,
    [DocumentTypePath.MORTGAGE_STATEMENT]: DocumentUploadType.MORTGAGE_STATEMENT,
    [DocumentTypePath.AVEN_SIGNING_DOCUMENT]: DocumentUploadType.AVEN_SIGNING_DOCUMENT,
    [DocumentTypePath.AVEN_SIGNED_DOCUMENT]: DocumentUploadType.AVEN_SIGNED_DOCUMENT,
    [DocumentTypePath.CREATOR_CHALLENGE_VIDEO]: DocumentUploadType.CREATOR_CHALLENGE_VIDEO,
    [DocumentTypePath.PROFIT_AND_LOSS]: DocumentUploadType.PROFIT_AND_LOSS,
    [DocumentTypePath.SOCIAL_SECURITY]: DocumentUploadType.SOCIAL_SECURITY,
    [DocumentTypePath.PENSION]: DocumentUploadType.PENSION,
    [DocumentTypePath.RETIREMENT]: DocumentUploadType.RETIREMENT,
    [DocumentTypePath.PRIOR_HELOC_STATEMENT]: DocumentUploadType.PRIOR_HELOC_STATEMENT,
    [DocumentTypePath.FIRST_LIEN_MORTGAGE_STATEMENT]: DocumentUploadType.FIRST_LIEN_MORTGAGE_STATEMENT,
    [DocumentTypePath.MULTI_LIEN_REFI_MORTGAGE_STATEMENT]: DocumentUploadType.MULTI_LIEN_REFI_MORTGAGE_STATEMENT,
    [DocumentTypePath.VERIFY_CURRENT_RENT_BANK_STATEMENT]: DocumentUploadType.VERIFY_CURRENT_RENT_BANK_STATEMENT,
    [DocumentTypePath.VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT]: DocumentUploadType.VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT,
    [DocumentTypePath.FORM_1099_R]: DocumentUploadType.FORM_1099_R,
    [DocumentTypePath.FORM_1099_SSA]: DocumentUploadType.FORM_1099_SSA,
    [DocumentTypePath.FORM_1099_MISC]: DocumentUploadType.FORM_1099_MISC,
    [DocumentTypePath.FORM_1099_NEC]: DocumentUploadType.FORM_1099_NEC,
    [DocumentTypePath.SCHEDULE_C]: DocumentUploadType.SCHEDULE_C,
    [DocumentTypePath.FIRST_LIEN_DOC]: DocumentUploadType.FIRST_LIEN_DOC,
    [DocumentTypePath.ALL_LIEN_DOC]: DocumentUploadType.ALL_LIEN_DOC,
    [DocumentTypePath.HELOC_REFI_PAYOFF_QUOTE]: DocumentUploadType.HELOC_REFI_PAYOFF_QUOTE,
    [DocumentTypePath.BANK_STATEMENT_ASSET_VERIFICATION]: DocumentUploadType.BANK_STATEMENT_ASSET_VERIFICATION,
    [DocumentTypePath.AVEN_ACCOUNT_TERMINATION_LETTER]: DocumentUploadType.AVEN_ACCOUNT_TERMINATION_LETTER,
    [DocumentTypePath.BANKRUPTCY_DOCUMENT]: DocumentUploadType.BANKRUPTCY_DOCUMENT,
    [DocumentTypePath.FORECLOSURE_SOT]: DocumentUploadType.FORECLOSURE_SOT,
    [DocumentTypePath.FORECLOSURE_NOD]: DocumentUploadType.FORECLOSURE_NOD,
    [DocumentTypePath.FORECLOSURE_OTHER]: DocumentUploadType.FORECLOSURE_OTHER,
    [DocumentTypePath.FORECLOSURE_TSG]: DocumentUploadType.FORECLOSURE_TSG,
    [DocumentTypePath.MANUAL_PAYOFF_QUOTE]: DocumentUploadType.MANUAL_PAYOFF_QUOTE,
    [DocumentTypePath.QUALIFIED_WRITTEN_REQUEST]: DocumentUploadType.QUALIFIED_WRITTEN_REQUEST,
    [DocumentTypePath.DEBT_VALIDATION_LETTER_RESPONSE]: DocumentUploadType.DEBT_VALIDATION_LETTER_RESPONSE,
    [DocumentTypePath.STATEMENT_RESERVES_VERIFICATION]: DocumentUploadType.STATEMENT_RESERVES_VERIFICATION,
    [DocumentTypePath.BROKERAGE_STATEMENT_ASSET_VERIFICATION]: DocumentUploadType.BROKERAGE_STATEMENT_ASSET_VERIFICATION,
    [DocumentTypePath.HELOC_REFI_LENDER_CONFIRMATION_OF_FUNDS_RECEIVED]: DocumentUploadType.HELOC_REFI_LENDER_CONFIRMATION_OF_FUNDS_RECEIVED,
    [DocumentTypePath.HELOC_REFI_PAID_IN_FULL_LETTER]: DocumentUploadType.HELOC_REFI_PAID_IN_FULL_LETTER,
    [DocumentTypePath.HELOC_REFI_SATISFACTION_OF_MORTGAGE]: DocumentUploadType.HELOC_REFI_SATISFACTION_OF_MORTGAGE,
    [DocumentTypePath.HELOC_REFI_RECORDED_RECONVEYANCE]: DocumentUploadType.HELOC_REFI_RECORDED_RECONVEYANCE,
    [DocumentTypePath.HELOC_REFI_SIGNED_BORROWER_AUTH]: DocumentUploadType.HELOC_REFI_SIGNED_BORROWER_AUTH,
    [DocumentTypePath.TITLE_INSURANCE_CLOSING_PACKAGE]: DocumentUploadType.TITLE_INSURANCE_CLOSING_PACKAGE,
    [DocumentTypePath.CLOSING_PACKAGE_ATTORNEY_APPROVAL]: DocumentUploadType.CLOSING_PACKAGE_ATTORNEY_APPROVAL,
    [DocumentTypePath.MORTGAGE_LAW_RETURN_DOCUMENT]: DocumentUploadType.MORTGAGE_LAW_RETURN_DOCUMENT,
    [DocumentTypePath.TITLE_INSURANCE_VESTING_DEED]: DocumentUploadType.TITLE_INSURANCE_VESTING_DEED,
    [DocumentTypePath.TITLE_INSURANCE_TAX_CERTIFICATE]: DocumentUploadType.TITLE_INSURANCE_TAX_CERTIFICATE,
    [DocumentTypePath.STATEMENT_OF_INFORMATION]: DocumentUploadType.STATEMENT_OF_INFORMATION,
    [DocumentTypePath.THIRD_PARTY_LEAD_TRANSFER_DEED]: DocumentUploadType.THIRD_PARTY_LEAD_TRANSFER_DEED,
    [DocumentTypePath.THIRD_PARTY_LEAD_IDENTITY_DOCUMENT]: DocumentUploadType.THIRD_PARTY_LEAD_IDENTITY_DOCUMENT,
    [DocumentTypePath.STATE_CLOSING_DOCUMENT]: DocumentUploadType.STATE_CLOSING_DOCUMENT,
    [DocumentTypePath.APPRAISAL_REPORT]: DocumentUploadType.APPRAISAL_REPORT,
    [DocumentTypePath.BALANCE_TRANSFER_SAVINGS_GUARANTEE_APR_VERIFICATION]: DocumentUploadType.BALANCE_TRANSFER_SAVINGS_GUARANTEE_APR_VERIFICATION,
    [DocumentTypePath.ARB_OPT_OUT]: DocumentUploadType.ARB_OPT_OUT,
    [DocumentTypePath.CIP_EVIDENCE]: DocumentUploadType.CIP_EVIDENCE,
    [DocumentTypePath.IDOLOGY_REPORT]: DocumentUploadType.IDOLOGY_REPORT,
    [DocumentTypePath.MERCHANT_CONTRACT]: DocumentUploadType.MERCHANT_CONTRACT,
    [DocumentTypePath.MERCHANT_WORK_ORDER]: DocumentUploadType.MERCHANT_WORK_ORDER,
    [DocumentTypePath.MERCHANT_ADDENDUM]: DocumentUploadType.MERCHANT_ADDENDUM,
    [DocumentTypePath.MERCHANT_COMPLETION_CERTIFICATE]: DocumentUploadType.MERCHANT_COMPLETION_CERTIFICATE,
    [DocumentTypePath.MERCHANT_JOB_PHOTO]: DocumentUploadType.MERCHANT_JOB_PHOTO,
    [DocumentTypePath.MERCHANT_OTHER]: DocumentUploadType.MERCHANT_OTHER,
    [DocumentTypePath.BUSINESS_ARTICLES_OF_ORGANIZATION]: DocumentUploadType.BUSINESS_ARTICLES_OF_ORGANIZATION,
    [DocumentTypePath.BUSINESS_CERTIFICATE_OF_GOOD_STANDING]: DocumentUploadType.BUSINESS_CERTIFICATE_OF_GOOD_STANDING,
    [DocumentTypePath.BUSINESS_OWNERSHIP_CERTIFICATION_OR_OPERATING_AGREEMENT]: DocumentUploadType.BUSINESS_OWNERSHIP_CERTIFICATION_OR_OPERATING_AGREEMENT,
    [DocumentTypePath.BUSINESS_OWNERSHIP_TAX_RETURN]: DocumentUploadType.BUSINESS_OWNERSHIP_TAX_RETURN,
    [DocumentTypePath.BUSINESS_OWNERSHIP_INCOME_DOC]: DocumentUploadType.BUSINESS_OWNERSHIP_INCOME_DOC,
    [DocumentTypePath.DEPOSIT_RECEIPT]: DocumentUploadType.DEPOSIT_RECEIPT,
    [DocumentTypePath.WIRE_CONFIRMATION]: DocumentUploadType.WIRE_CONFIRMATION,
    [DocumentTypePath.GIFT_LETTER]: DocumentUploadType.GIFT_LETTER,
    [DocumentTypePath.BILL_OF_SALE]: DocumentUploadType.BILL_OF_SALE,
    [DocumentTypePath.SETTLEMENT_STATEMENT]: DocumentUploadType.SETTLEMENT_STATEMENT,
    [DocumentTypePath.ESCROW_STATEMENT]: DocumentUploadType.ESCROW_STATEMENT,
    [DocumentTypePath.BROKERAGE_STATEMENT]: DocumentUploadType.BROKERAGE_STATEMENT,
    [DocumentTypePath.RETIREMENT_ACCOUNT_STATEMENT]: DocumentUploadType.RETIREMENT_ACCOUNT_STATEMENT,
    [DocumentTypePath.INSURANCE_CLAIM_DOCUMENTATION]: DocumentUploadType.INSURANCE_CLAIM_DOCUMENTATION,
    [DocumentTypePath.COURT_SETTLEMENT_DOCUMENTS]: DocumentUploadType.COURT_SETTLEMENT_DOCUMENTS,
    [DocumentTypePath.TRUST_OR_ESTATE_DOCUMENTS]: DocumentUploadType.TRUST_OR_ESTATE_DOCUMENTS,
    [DocumentTypePath.CERTIFICATE_OF_TRUST]: DocumentUploadType.CERTIFICATE_OF_TRUST,
    [DocumentTypePath.LOAN_AGREEMENT_OR_PROMISSORY_NOTE]: DocumentUploadType.LOAN_AGREEMENT_OR_PROMISSORY_NOTE,
    [DocumentTypePath.INHERITANCE_DOCUMENTATION]: DocumentUploadType.INHERITANCE_DOCUMENTATION,
    [DocumentTypePath.INVOICE_AND_PROOF_OF_PAYMENT]: DocumentUploadType.INVOICE_AND_PROOF_OF_PAYMENT,
    [DocumentTypePath.BUSINESS_FINANCIAL_STATEMENTS]: DocumentUploadType.BUSINESS_FINANCIAL_STATEMENTS,
    // Employment & Income
    [DocumentTypePath.PAYROLL_DIRECT_DEPOSIT]: DocumentUploadType.PAYROLL_DIRECT_DEPOSIT,
    [DocumentTypePath.BONUS]: DocumentUploadType.BONUS,
    [DocumentTypePath.COMMISSION]: DocumentUploadType.COMMISSION,
    [DocumentTypePath.OVERTIME_PAY]: DocumentUploadType.OVERTIME_PAY,
    [DocumentTypePath.TIPS]: DocumentUploadType.TIPS,
    [DocumentTypePath.SEVERANCE_PAY]: DocumentUploadType.SEVERANCE_PAY,
    [DocumentTypePath.PTO_PAY_OUT]: DocumentUploadType.PTO_PAY_OUT,
    [DocumentTypePath.EXPENSE_REIMBURSEMENT]: DocumentUploadType.EXPENSE_REIMBURSEMENT,
    [DocumentTypePath.INDEPENDENT_CONTRACTOR_INCOME]: DocumentUploadType.INDEPENDENT_CONTRACTOR_INCOME,
    [DocumentTypePath.SELF_EMPLOYMENT_BUSINESS_INCOME]: DocumentUploadType.SELF_EMPLOYMENT_BUSINESS_INCOME,
    // Retirement & Government Benefits
    [DocumentTypePath.SOCIAL_SECURITY_RETIREMENT]: DocumentUploadType.SOCIAL_SECURITY_RETIREMENT,
    [DocumentTypePath.SOCIAL_SECURITY_DISABILITY]: DocumentUploadType.SOCIAL_SECURITY_DISABILITY,
    [DocumentTypePath.SUPPLEMENTAL_SECURITY_INCOME]: DocumentUploadType.SUPPLEMENTAL_SECURITY_INCOME,
    [DocumentTypePath.ANNUITY_PAYMENTS]: DocumentUploadType.ANNUITY_PAYMENTS,
    [DocumentTypePath.VETERANS_BENEFITS]: DocumentUploadType.VETERANS_BENEFITS,
    [DocumentTypePath.RAILROAD_RETIREMENT]: DocumentUploadType.RAILROAD_RETIREMENT,
    [DocumentTypePath.STATE_RETIREMENT_BENEFITS]: DocumentUploadType.STATE_RETIREMENT_BENEFITS,
    [DocumentTypePath.MILITARY_RETIREMENT]: DocumentUploadType.MILITARY_RETIREMENT,
    // Transfers
    [DocumentTypePath.TRANSFER_FROM_PERSONAL_ACCOUNT]: DocumentUploadType.TRANSFER_FROM_PERSONAL_ACCOUNT,
    [DocumentTypePath.TRANSFER_FROM_JOINT_ACCOUNT]: DocumentUploadType.TRANSFER_FROM_JOINT_ACCOUNT,
    [DocumentTypePath.BROKERAGE_ACCOUNT_TRANSFER]: DocumentUploadType.BROKERAGE_ACCOUNT_TRANSFER,
    [DocumentTypePath.SAVINGS_ACCOUNT_TRANSFER]: DocumentUploadType.SAVINGS_ACCOUNT_TRANSFER,
    [DocumentTypePath.CREDIT_UNION_TRANSFER]: DocumentUploadType.CREDIT_UNION_TRANSFER,
    [DocumentTypePath.MONEY_MARKET_TRANSFER]: DocumentUploadType.MONEY_MARKET_TRANSFER,
    [DocumentTypePath.TRUST_ACCOUNT_TRANSFER]: DocumentUploadType.TRUST_ACCOUNT_TRANSFER,
    [DocumentTypePath.CD_MATURITY_PROCEEDS]: DocumentUploadType.CD_MATURITY_PROCEEDS,
    [DocumentTypePath.INTERNATIONAL_WIRE_TRANSFER]: DocumentUploadType.INTERNATIONAL_WIRE_TRANSFER,
    [DocumentTypePath.INTERNAL_BANK_TRANSFER]: DocumentUploadType.INTERNAL_BANK_TRANSFER,
    // Sale of Assets
    [DocumentTypePath.SALE_OF_HOME]: DocumentUploadType.SALE_OF_HOME,
    [DocumentTypePath.SALE_OF_LAND]: DocumentUploadType.SALE_OF_LAND,
    [DocumentTypePath.SALE_OF_VEHICLE]: DocumentUploadType.SALE_OF_VEHICLE,
    [DocumentTypePath.SALE_OF_BOAT]: DocumentUploadType.SALE_OF_BOAT,
    [DocumentTypePath.SALE_OF_RV]: DocumentUploadType.SALE_OF_RV,
    [DocumentTypePath.SALE_OF_MOTORCYCLE]: DocumentUploadType.SALE_OF_MOTORCYCLE,
    [DocumentTypePath.SALE_OF_BUSINESS]: DocumentUploadType.SALE_OF_BUSINESS,
    [DocumentTypePath.SALE_OF_STOCKS]: DocumentUploadType.SALE_OF_STOCKS,
    [DocumentTypePath.SALE_OF_BONDS]: DocumentUploadType.SALE_OF_BONDS,
    [DocumentTypePath.SALE_OF_MUTUAL_FUNDS]: DocumentUploadType.SALE_OF_MUTUAL_FUNDS,
    [DocumentTypePath.SALE_OF_CRYPTOCURRENCY]: DocumentUploadType.SALE_OF_CRYPTOCURRENCY,
    [DocumentTypePath.SALE_OF_COLLECTIBLES]: DocumentUploadType.SALE_OF_COLLECTIBLES,
    [DocumentTypePath.ESTATE_SALE_PROCEEDS]: DocumentUploadType.ESTATE_SALE_PROCEEDS,
    // Investments
    [DocumentTypePath.STOCK_DIVIDENDS]: DocumentUploadType.STOCK_DIVIDENDS,
    [DocumentTypePath.BOND_INTEREST]: DocumentUploadType.BOND_INTEREST,
    [DocumentTypePath.MUTUAL_FUND_DISTRIBUTION]: DocumentUploadType.MUTUAL_FUND_DISTRIBUTION,
    [DocumentTypePath.CAPITAL_GAINS_DISTRIBUTION]: DocumentUploadType.CAPITAL_GAINS_DISTRIBUTION,
    [DocumentTypePath.INVESTMENT_ACCOUNT_WITHDRAWAL]: DocumentUploadType.INVESTMENT_ACCOUNT_WITHDRAWAL,
    [DocumentTypePath.RETIREMENT_ACCOUNT_DISTRIBUTION]: DocumentUploadType.RETIREMENT_ACCOUNT_DISTRIBUTION,
    [DocumentTypePath.REQUIRED_MINIMUM_DISTRIBUTION]: DocumentUploadType.REQUIRED_MINIMUM_DISTRIBUTION,
    // Insurance
    [DocumentTypePath.LIFE_INSURANCE_PAYOUT]: DocumentUploadType.LIFE_INSURANCE_PAYOUT,
    [DocumentTypePath.HEALTH_INSURANCE_REIMBURSEMENT]: DocumentUploadType.HEALTH_INSURANCE_REIMBURSEMENT,
    [DocumentTypePath.AUTO_INSURANCE_CLAIM]: DocumentUploadType.AUTO_INSURANCE_CLAIM,
    [DocumentTypePath.HOMEOWNERS_INSURANCE_CLAIM]: DocumentUploadType.HOMEOWNERS_INSURANCE_CLAIM,
    [DocumentTypePath.DISABILITY_INSURANCE_BENEFITS]: DocumentUploadType.DISABILITY_INSURANCE_BENEFITS,
    [DocumentTypePath.LONG_TERM_CARE_INSURANCE_PAYOUT]: DocumentUploadType.LONG_TERM_CARE_INSURANCE_PAYOUT,
    // Real Estate
    [DocumentTypePath.RENTAL_INCOME]: DocumentUploadType.RENTAL_INCOME,
    [DocumentTypePath.SECURITY_DEPOSIT_REFUND]: DocumentUploadType.SECURITY_DEPOSIT_REFUND,
    [DocumentTypePath.ESCROW_REFUND]: DocumentUploadType.ESCROW_REFUND,
    [DocumentTypePath.PROPERTY_TAX_REFUND]: DocumentUploadType.PROPERTY_TAX_REFUND,
    [DocumentTypePath.MORTGAGE_ESCROW_SURPLUS]: DocumentUploadType.MORTGAGE_ESCROW_SURPLUS,
    [DocumentTypePath.HOME_EQUITY_LOAN_PROCEEDS]: DocumentUploadType.HOME_EQUITY_LOAN_PROCEEDS,
    [DocumentTypePath.HELOC_ADVANCE]: DocumentUploadType.HELOC_ADVANCE,
    [DocumentTypePath.CASH_OUT_REFINANCE_PROCEEDS]: DocumentUploadType.CASH_OUT_REFINANCE_PROCEEDS,
    [DocumentTypePath.HOME_SALE_PROCEEDS]: DocumentUploadType.HOME_SALE_PROCEEDS,
    // Loans
    [DocumentTypePath.PERSONAL_LOAN_PROCEEDS]: DocumentUploadType.PERSONAL_LOAN_PROCEEDS,
    [DocumentTypePath.AUTO_LOAN_PROCEEDS]: DocumentUploadType.AUTO_LOAN_PROCEEDS,
    [DocumentTypePath.STUDENT_LOAN_DISBURSEMENT]: DocumentUploadType.STUDENT_LOAN_DISBURSEMENT,
    [DocumentTypePath.BUSINESS_LOAN_PROCEEDS]: DocumentUploadType.BUSINESS_LOAN_PROCEEDS,
    [DocumentTypePath.SBA_LOAN_PROCEEDS]: DocumentUploadType.SBA_LOAN_PROCEEDS,
    [DocumentTypePath.CONSTRUCTION_LOAN_DRAW]: DocumentUploadType.CONSTRUCTION_LOAN_DRAW,
    [DocumentTypePath.PRIVATE_LOAN_FROM_FAMILY_FRIEND]: DocumentUploadType.PRIVATE_LOAN_FROM_FAMILY_FRIEND,
    [DocumentTypePath.MARGIN_LOAN]: DocumentUploadType.MARGIN_LOAN,
    [DocumentTypePath.LINE_OF_CREDIT_ADVANCE]: DocumentUploadType.LINE_OF_CREDIT_ADVANCE,
    // Gifts & Family
    [DocumentTypePath.GIFT_FROM_FAMILY_MEMBER]: DocumentUploadType.GIFT_FROM_FAMILY_MEMBER,
    [DocumentTypePath.GIFT_FROM_FRIEND]: DocumentUploadType.GIFT_FROM_FRIEND,
    [DocumentTypePath.WEDDING_GIFT]: DocumentUploadType.WEDDING_GIFT,
    [DocumentTypePath.GRADUATION_GIFT]: DocumentUploadType.GRADUATION_GIFT,
    [DocumentTypePath.BIRTHDAY_GIFT]: DocumentUploadType.BIRTHDAY_GIFT,
    [DocumentTypePath.INHERITANCE]: DocumentUploadType.INHERITANCE,
    [DocumentTypePath.TRUST_DISTRIBUTION]: DocumentUploadType.TRUST_DISTRIBUTION,
    // Legal & Settlement
    [DocumentTypePath.LAWSUIT_SETTLEMENT]: DocumentUploadType.LAWSUIT_SETTLEMENT,
    [DocumentTypePath.CLASS_ACTION_SETTLEMENT]: DocumentUploadType.CLASS_ACTION_SETTLEMENT,
    [DocumentTypePath.WORKERS_COMPENSATION_SETTLEMENT]: DocumentUploadType.WORKERS_COMPENSATION_SETTLEMENT,
    [DocumentTypePath.PERSONAL_INJURY_SETTLEMENT]: DocumentUploadType.PERSONAL_INJURY_SETTLEMENT,
    [DocumentTypePath.DIVORCE_SETTLEMENT]: DocumentUploadType.DIVORCE_SETTLEMENT,
    [DocumentTypePath.CHILD_SUPPORT_PAYMENT]: DocumentUploadType.CHILD_SUPPORT_PAYMENT,
    [DocumentTypePath.ALIMONY]: DocumentUploadType.ALIMONY,
    [DocumentTypePath.ESTATE_DISTRIBUTION]: DocumentUploadType.ESTATE_DISTRIBUTION,
    // Business
    [DocumentTypePath.CUSTOMER_PAYMENTS]: DocumentUploadType.CUSTOMER_PAYMENTS,
    [DocumentTypePath.MERCHANT_SERVICES_DEPOSITS]: DocumentUploadType.MERCHANT_SERVICES_DEPOSITS,
    [DocumentTypePath.ACCOUNTS_RECEIVABLE_COLLECTIONS]: DocumentUploadType.ACCOUNTS_RECEIVABLE_COLLECTIONS,
    [DocumentTypePath.VENDOR_REFUND]: DocumentUploadType.VENDOR_REFUND,
    [DocumentTypePath.TAX_REFUND_TO_BUSINESS]: DocumentUploadType.TAX_REFUND_TO_BUSINESS,
    [DocumentTypePath.OWNER_CONTRIBUTION]: DocumentUploadType.OWNER_CONTRIBUTION,
    [DocumentTypePath.PARTNER_CAPITAL_CONTRIBUTION]: DocumentUploadType.PARTNER_CAPITAL_CONTRIBUTION,
    [DocumentTypePath.BUSINESS_INSURANCE_CLAIM]: DocumentUploadType.BUSINESS_INSURANCE_CLAIM,
    // Tax-Related
    [DocumentTypePath.FEDERAL_INCOME_TAX_REFUND]: DocumentUploadType.FEDERAL_INCOME_TAX_REFUND,
    [DocumentTypePath.STATE_INCOME_TAX_REFUND]: DocumentUploadType.STATE_INCOME_TAX_REFUND,
    [DocumentTypePath.SALES_TAX_REFUND]: DocumentUploadType.SALES_TAX_REFUND,
    [DocumentTypePath.IRS_CREDIT_OR_REBATE]: DocumentUploadType.IRS_CREDIT_OR_REBATE,
    // Education
    [DocumentTypePath.STUDENT_FINANCIAL_AID_REFUND]: DocumentUploadType.STUDENT_FINANCIAL_AID_REFUND,
    [DocumentTypePath.SCHOLARSHIP_REFUND]: DocumentUploadType.SCHOLARSHIP_REFUND,
    [DocumentTypePath.GRANT_PROCEEDS]: DocumentUploadType.GRANT_PROCEEDS,
    [DocumentTypePath.TUITION_REIMBURSEMENT]: DocumentUploadType.TUITION_REIMBURSEMENT,
    // Gambling & Gaming
    [DocumentTypePath.CASINO_WINNINGS]: DocumentUploadType.CASINO_WINNINGS,
    [DocumentTypePath.LOTTERY_WINNINGS]: DocumentUploadType.LOTTERY_WINNINGS,
    [DocumentTypePath.SPORTS_BETTING_WINNINGS]: DocumentUploadType.SPORTS_BETTING_WINNINGS,
    [DocumentTypePath.POKER_TOURNAMENT_WINNINGS]: DocumentUploadType.POKER_TOURNAMENT_WINNINGS,
    [DocumentTypePath.SWEEPSTAKES_PRIZE]: DocumentUploadType.SWEEPSTAKES_PRIZE,
    // Online Platforms
    [DocumentTypePath.PAYPAL_TRANSFER]: DocumentUploadType.PAYPAL_TRANSFER,
    [DocumentTypePath.VENMO_TRANSFER]: DocumentUploadType.VENMO_TRANSFER,
    [DocumentTypePath.CASH_APP_TRANSFER]: DocumentUploadType.CASH_APP_TRANSFER,
    [DocumentTypePath.ZELLE_PAYMENT]: DocumentUploadType.ZELLE_PAYMENT,
    [DocumentTypePath.STRIPE_PAYOUT]: DocumentUploadType.STRIPE_PAYOUT,
    [DocumentTypePath.SQUARE_PAYOUT]: DocumentUploadType.SQUARE_PAYOUT,
    [DocumentTypePath.ETSY_PAYOUT]: DocumentUploadType.ETSY_PAYOUT,
    [DocumentTypePath.EBAY_PAYOUT]: DocumentUploadType.EBAY_PAYOUT,
    [DocumentTypePath.AMAZON_SELLER_PAYOUT]: DocumentUploadType.AMAZON_SELLER_PAYOUT,
    [DocumentTypePath.AIRBNB_PAYOUT]: DocumentUploadType.AIRBNB_PAYOUT,
    [DocumentTypePath.VRBO_PAYOUT]: DocumentUploadType.VRBO_PAYOUT,
    [DocumentTypePath.UBER_LYFT_EARNINGS]: DocumentUploadType.UBER_LYFT_EARNINGS,
    [DocumentTypePath.DOOR_DASH_INSTACART_EARNINGS]: DocumentUploadType.DOOR_DASH_INSTACART_EARNINGS,
    // Cash Deposits
    [DocumentTypePath.PERSONAL_CASH_SAVINGS]: DocumentUploadType.PERSONAL_CASH_SAVINGS,
    [DocumentTypePath.CASH_FROM_BUSINESS_RECEIPTS]: DocumentUploadType.CASH_FROM_BUSINESS_RECEIPTS,
    [DocumentTypePath.CASH_GIFT]: DocumentUploadType.CASH_GIFT,
    [DocumentTypePath.CASH_FROM_SALE_OF_PERSONAL_PROPERTY]: DocumentUploadType.CASH_FROM_SALE_OF_PERSONAL_PROPERTY,
    // Refunds & Credits
    [DocumentTypePath.MERCHANT_REFUND]: DocumentUploadType.MERCHANT_REFUND,
    [DocumentTypePath.CREDIT_CARD_REFUND]: DocumentUploadType.CREDIT_CARD_REFUND,
    [DocumentTypePath.UTILITY_DEPOSIT_REFUND]: DocumentUploadType.UTILITY_DEPOSIT_REFUND,
    [DocumentTypePath.WARRANTY_REIMBURSEMENT]: DocumentUploadType.WARRANTY_REIMBURSEMENT,
    [DocumentTypePath.MANUFACTURER_REBATE]: DocumentUploadType.MANUFACTURER_REBATE,
    // Miscellaneous
    [DocumentTypePath.PRIZE_OR_AWARD]: DocumentUploadType.PRIZE_OR_AWARD,
    [DocumentTypePath.ROYALTIES]: DocumentUploadType.ROYALTIES,
    [DocumentTypePath.LICENSING_INCOME]: DocumentUploadType.LICENSING_INCOME,
    [DocumentTypePath.PATENT_INCOME]: DocumentUploadType.PATENT_INCOME,
    [DocumentTypePath.COPYRIGHT_INCOME]: DocumentUploadType.COPYRIGHT_INCOME,
    [DocumentTypePath.MINERAL_OR_OIL_RIGHTS_ROYALTIES]: DocumentUploadType.MINERAL_OR_OIL_RIGHTS_ROYALTIES,
    [DocumentTypePath.CROWDFUNDING_PROCEEDS]: DocumentUploadType.CROWDFUNDING_PROCEEDS,
    [DocumentTypePath.CHARITABLE_GRANT]: DocumentUploadType.CHARITABLE_GRANT,
    [DocumentTypePath.CHURCH_ASSISTANCE]: DocumentUploadType.CHURCH_ASSISTANCE,
    [DocumentTypePath.DISASTER_RELIEF_FUNDS]: DocumentUploadType.DISASTER_RELIEF_FUNDS,
    [DocumentTypePath.FOREIGN_CURRENCY_EXCHANGE_PROCEEDS]: DocumentUploadType.FOREIGN_CURRENCY_EXCHANGE_PROCEEDS,
    // Post-notarization review requestable documents.
    [DocumentTypePath.US_DRIVERS_LICENSE]: DocumentUploadType.US_DRIVERS_LICENSE,
    [DocumentTypePath.US_STATE_ID_CARD]: DocumentUploadType.US_STATE_ID_CARD,
    [DocumentTypePath.US_PASSPORT]: DocumentUploadType.US_PASSPORT,
    [DocumentTypePath.US_PASSPORT_CARD]: DocumentUploadType.US_PASSPORT_CARD,
    [DocumentTypePath.US_PERMANENT_RESIDENT_CARD]: DocumentUploadType.US_PERMANENT_RESIDENT_CARD,
    [DocumentTypePath.TRIBAL_ID_CARD]: DocumentUploadType.TRIBAL_ID_CARD,
    [DocumentTypePath.US_DEPT_OF_STATE_DRIVERS_LICENSE]: DocumentUploadType.US_DEPT_OF_STATE_DRIVERS_LICENSE,
    [DocumentTypePath.US_EMPLOYMENT_AUTHORIZATION_CARD]: DocumentUploadType.US_EMPLOYMENT_AUTHORIZATION_CARD,
    [DocumentTypePath.US_BIRTH_CERTIFICATE]: DocumentUploadType.US_BIRTH_CERTIFICATE,
    [DocumentTypePath.US_MILITARY_ID]: DocumentUploadType.US_MILITARY_ID,
    [DocumentTypePath.GLOBAL_ENTRY_CARD]: DocumentUploadType.GLOBAL_ENTRY_CARD,
    [DocumentTypePath.US_CERTIFICATE_OF_NATURALIZATION]: DocumentUploadType.US_CERTIFICATE_OF_NATURALIZATION,
    [DocumentTypePath.FOREIGN_PASSPORT]: DocumentUploadType.FOREIGN_PASSPORT,
    [DocumentTypePath.STATE_DIGITAL_ID]: DocumentUploadType.STATE_DIGITAL_ID,
    [DocumentTypePath.ITIN_ASSIGNMENT_LETTER_CP565]: DocumentUploadType.ITIN_ASSIGNMENT_LETTER_CP565,
    [DocumentTypePath.PROPERTY_TAX_STATEMENT]: DocumentUploadType.PROPERTY_TAX_STATEMENT,
    [DocumentTypePath.LANDLORD_INSURANCE_POLICY]: DocumentUploadType.LANDLORD_INSURANCE_POLICY,
    [DocumentTypePath.LEASE_AGREEMENT]: DocumentUploadType.LEASE_AGREEMENT,
    [DocumentTypePath.MARRIAGE_CERTIFICATE]: DocumentUploadType.MARRIAGE_CERTIFICATE,
    [DocumentTypePath.COURT_ORDER_NAME_CHANGE]: DocumentUploadType.COURT_ORDER_NAME_CHANGE,
    [DocumentTypePath.FORM_1099_B]: DocumentUploadType.FORM_1099_B,
    [DocumentTypePath.POWER_OF_ATTORNEY]: DocumentUploadType.POWER_OF_ATTORNEY,
    [DocumentTypePath.IDENTITY_THEFT_WRITTEN_STATEMENT]: DocumentUploadType.IDENTITY_THEFT_WRITTEN_STATEMENT,
    [DocumentTypePath.PERSONA_SESSION]: DocumentUploadType.PERSONA_SESSION,
    [DocumentTypePath.IDOLOGY_KBA]: DocumentUploadType.IDOLOGY_KBA,
};
exports.documentPathForType = lodash_1.default.invert(exports.documentTypeForPath);
// these are the currently supported types for manual income review.
// use only the key strings as valid values for upload type in apiRouter.ts
// use only the value strings as valid values in incomeVerificationController.ts
exports.supportedManualReviewIncomes = {
    [DocumentTypePath.TAX_RETURN]: DocumentUploadType.TAX_RETURN,
    [DocumentTypePath.IRS_RECORD_OF_ACCOUNT]: DocumentUploadType.IRS_RECORD_OF_ACCOUNT,
    [DocumentTypePath.IRS_WAGE_AND_INCOME_TRANSCRIPT]: DocumentUploadType.IRS_WAGE_AND_INCOME_TRANSCRIPT,
    [DocumentTypePath.IRS_REJECTION_NOTICE]: DocumentUploadType.IRS_REJECTION_NOTICE,
    [DocumentTypePath.PAY_STUB]: DocumentUploadType.PAY_STUB,
    [DocumentTypePath.W2]: DocumentUploadType.W2,
    [DocumentTypePath.FORM_1099]: DocumentUploadType.FORM_1099,
    [DocumentTypePath.BANK_STATEMENT]: DocumentUploadType.BANK_STATEMENT,
    [DocumentTypePath.UTILITY_BILL]: DocumentUploadType.INSURANCE_DOCUMENT,
    [DocumentTypePath.INSURANCE_DOCUMENT]: DocumentUploadType.INSURANCE_DOCUMENT,
    [DocumentTypePath.BENEFIT_LETTER]: DocumentUploadType.BENEFIT_LETTER,
    [DocumentTypePath.OTHER_INCOME_LETTER]: DocumentUploadType.OTHER_INCOME_LETTER,
    [DocumentTypePath.PROFIT_AND_LOSS]: DocumentUploadType.PROFIT_AND_LOSS,
    [DocumentTypePath.SOCIAL_SECURITY]: DocumentUploadType.SOCIAL_SECURITY,
    [DocumentTypePath.PENSION]: DocumentUploadType.PENSION,
    [DocumentTypePath.RETIREMENT]: DocumentUploadType.RETIREMENT,
    // TODO(davi) Maybe? [DocumentTypePath.STATEMENT_RESERVES_VERIFICATION]: DocumentUploadType.STATEMENT_RESERVES_VERIFICATION,
};
exports.supportedNonOwnerOccupiedCurrentRent = {
    [DocumentTypePath.VERIFY_CURRENT_RENT_BANK_STATEMENT]: DocumentUploadType.VERIFY_CURRENT_RENT_BANK_STATEMENT,
    [DocumentTypePath.VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT]: DocumentUploadType.VERIFY_CURRENT_RENT_PROPERTY_MGMT_STATEMENT,
};
exports.supportedManualReviewProperty = {
    [DocumentTypePath.UTILITY_BILL]: DocumentUploadType.UTILITY_BILL,
    [DocumentTypePath.INSURANCE_DOCUMENT]: DocumentUploadType.INSURANCE_DOCUMENT,
};
exports.supportedMortgageDocuments = {
    [DocumentTypePath.SUPPORTING_DOCUMENT]: DocumentUploadType.SUPPORTING_DOCUMENT,
    [DocumentTypePath.IDENTITY_DOCUMENT]: DocumentUploadType.IDENTITY_DOCUMENT,
    [DocumentTypePath.PAY_STUB]: DocumentUploadType.PAY_STUB,
    [DocumentTypePath.W2]: DocumentUploadType.W2,
    [DocumentTypePath.BANK_STATEMENT]: DocumentUploadType.BANK_STATEMENT,
    [DocumentTypePath.RETIREMENT]: DocumentUploadType.RETIREMENT,
    [DocumentTypePath.MORTGAGE_STATEMENT]: DocumentUploadType.MORTGAGE_STATEMENT,
    [DocumentTypePath.HOMEOWNERS_INSURANCE_DOCUMENT]: DocumentUploadType.HOMEOWNERS_INSURANCE_DOCUMENT,
    [DocumentTypePath.FLOOD_INSURANCE_DOCUMENT]: DocumentUploadType.FLOOD_INSURANCE_DOCUMENT,
    [DocumentTypePath.CONDO_HOA_DOCUMENT]: DocumentUploadType.CONDO_HOA_DOCUMENT,
};
var UserDocumentUploadErrors;
(function (UserDocumentUploadErrors) {
    UserDocumentUploadErrors["ERROR_UNSUPPORTED_DOCUMENT_TYPE"] = "ERROR_UNSUPPORTED_DOCUMENT_TYPE";
    UserDocumentUploadErrors["ERROR_INVALID_CREDENTIALS"] = "ERROR_INVALID_CREDENTIALS";
    UserDocumentUploadErrors["DOCUMENT_TOO_OLD"] = "DOCUMENT_TOO_OLD";
    UserDocumentUploadErrors["PAYSTUB_NOT_DETECTED"] = "PAYSTUB_NOT_DETECTED";
    UserDocumentUploadErrors["TAX_RETURN_NOT_DETECTED"] = "TAX_RETURN_NOT_DETECTED";
    UserDocumentUploadErrors["FORM_1099_NOT_DETECTED"] = "FORM_1099_NOT_DETECTED";
    UserDocumentUploadErrors["W2_NOT_DETECTED"] = "W2_NOT_DETECTED";
    UserDocumentUploadErrors["BENEFIT_LETTER_NOT_DETECTED"] = "BENEFIT_LETTER_NOT_DETECTED";
    UserDocumentUploadErrors["INCOME_INSUFFICIENT_FROM_LLM_MODEL"] = "INCOME_INSUFFICIENT_FROM_LLM_MODEL";
    UserDocumentUploadErrors["LLM_EXTRACTION_LOW_CONFIDENCE"] = "LLM_EXTRACTION_LOW_CONFIDENCE";
    UserDocumentUploadErrors["LLM_EXTRACTION_FAILED"] = "LLM_EXTRACTION_FAILED";
    UserDocumentUploadErrors["DOCUMENT_PARSED_BUT_REJECTED_FOR_OTHER_REASON"] = "DOCUMENT_PARSED_BUT_REJECTED_FOR_OTHER_REASON";
    UserDocumentUploadErrors["DOCUMENT_MISSING_INFO"] = "DOCUMENT_MISSING_INFO";
    UserDocumentUploadErrors["DOCUMENT_NAME_MISMATCH"] = "DOCUMENT_NAME_MISMATCH";
    UserDocumentUploadErrors["SUSPICIOUS_DOC"] = "SUSPICIOUS_DOC";
    UserDocumentUploadErrors["DOCUMENT_ENCRYPTED_OR_MALFORMED"] = "DOCUMENT_ENCRYPTED_OR_MALFORMED";
    UserDocumentUploadErrors["ERROR_DOCUMENT_TYPE_DISABLED_FOR_APPLICANT"] = "ERROR_DOCUMENT_TYPE_DISABLED_FOR_APPLICANT";
})(UserDocumentUploadErrors || (exports.UserDocumentUploadErrors = UserDocumentUploadErrors = {}));
// These are the only currrently supported document types for third party lead
exports.supportedThirdPartyLeadDocumentPathToTypeMap = {
    [DocumentTypePath.THIRD_PARTY_LEAD_TRANSFER_DEED]: DocumentUploadType.THIRD_PARTY_LEAD_TRANSFER_DEED,
    [DocumentTypePath.THIRD_PARTY_LEAD_IDENTITY_DOCUMENT]: DocumentUploadType.THIRD_PARTY_LEAD_IDENTITY_DOCUMENT,
};
exports.supportedThirdPartyLeadDocumentTypeToPathMap = Object.fromEntries(Object.entries(exports.supportedThirdPartyLeadDocumentPathToTypeMap).map(([path, type]) => [type, path]));
exports.supportedMerchantDocumentTypes = [
    DocumentUploadType.MERCHANT_CONTRACT,
    DocumentUploadType.MERCHANT_WORK_ORDER,
    DocumentUploadType.MERCHANT_ADDENDUM,
    DocumentUploadType.MERCHANT_COMPLETION_CERTIFICATE,
    DocumentUploadType.MERCHANT_JOB_PHOTO,
    DocumentUploadType.MERCHANT_OTHER,
];
// useful for type narrowing
function isMerchantDocumentType(type) {
    return exports.supportedMerchantDocumentTypes.includes(type);
}
